<template>
  <div class="con-wrap monitor-wrap" ref="conWrap">
    <div id="map-box" v-loading="loading" element-loading-text="数据加载中,请耐心等候.." class="box-border"></div>
    <el-header class="watch-header">
      <el-row class="header-title">车辆运行监控</el-row>
      <el-row class="deptName">{{ companyName }}</el-row>
      <el-row class="search-menu">
        <el-form
          size="medium"
          :model="queryForm"
          ref="queryForm"
          class="input-form-inline"
          :class="{ error: errorShow, normal: normalShow }"
          @submit.native.prevent
        >
          <el-form-item>
            <el-autocomplete
              v-model.trim="searchData"
              :fetch-suggestions="querySearchAsync"
              placeholder="车牌号/车辆绑定人"
              :popper-append-to-body="false"
              style="width: 100%"
              ref="selectInput"
            >
              <el-button slot="append" icon="el-icon-search" @click="searchVehicle($event)"></el-button>
            </el-autocomplete>
            <!-- <el-input
              v-model.trim="searchData"
              @keyup.enter.native="searchVehicle"
              placeholder="车牌号/车辆绑定人"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="searchVehicle"
              ></el-button>
            </el-input>-->
          </el-form-item>
        </el-form>
      </el-row>
    </el-header>
    <el-row class="reload-time">
      数据刷新时间：
      <span>{{ refreshTime }}</span>
    </el-row>
    <div
      class="openLeftRetract"
      @click="surveyLeftShowClick"
      :style="{
      left: surveyLeftShow ? '360px' : '30px',
      top: surveyLeftShow ? '98px' : '98px',
    }"
    >
      <i
        class="iconfont iconjiantoushang"
        :style="{
        transform: surveyLeftShow ? 'rotate(-90deg)' : 'rotate(90deg)',
      }"
      ></i>
    </div>
    <div class="survey-wrapper left-survey" v-show="surveyLeftShow">
      <div class="survey">
        <p class="survey-title">车辆概况</p>
        <el-row class="survey-vehicle">
          <el-col :span="8" class="vehicle" @click.native="goToVehicle(2)">
            <div class="vehicleCharts" id="onlineCharts"></div>
            <el-row class="vehicle_num">
              <p class="num">{{ monitorData.vehicle.onLineCount }}</p>
              <p class="desc">在线</p>
            </el-row>
          </el-col>
          <el-col :span="8" class="vehicle" @click.native="goToVehicle(1)">
            <div class="vehicleCharts" id="offlineCharts"></div>
            <el-row class="vehicle_num">
              <p class="num">{{ monitorData.vehicle.offLineCount }}</p>
              <p class="desc">待命</p>
            </el-row>
          </el-col>
          <el-col :span="8" class="vehicle" @click.native="goToVehicle(3)">
            <div class="vehicleCharts" id="powerCharts"></div>
            <el-row class="vehicle_num">
              <p class="num">{{ monitorData.vehicle.powerCount }}</p>
              <p class="desc">发电中</p>
            </el-row>
          </el-col>
        </el-row>
      </div>
      <div class="survey">
        <p class="survey-title">站址概况</p>
        <el-row class="survey-base">
          <el-col :span="12" class="base allBase" style="cursor: inherit">
            <p class="base_num">{{ monitorData.station.totalCount }}</p>
            <p class="base_title">站址数</p>
          </el-col>
          <el-col :span="12" class="base faultBase" style="cursor: inherit">
            <p class="base_num">{{ monitorData.station.errorCount }}</p>
            <p class="base_title">告警数</p>
          </el-col>
        </el-row>
      </div>
      <div class="survey">
        <p class="survey-title">工单概况</p>
        <el-row class="survey-base">
          <el-col :span="12" class="base ordering" @click.native="goToOrder(2)">
            <p class="base_num">{{ monitorData.order.onWayCount }}</p>
            <p class="base_title">在途工单</p>
          </el-col>
          <el-col :span="12" class="base order" @click.native="goToOrder(1)">
            <p class="base_num">{{ monitorData.order.waitCount }}</p>
            <p class="base_title">待接工单</p>
          </el-col>
        </el-row>
      </div>
      <div class="survey" v-show="hasPerm('maintain:monitor:order:mouth:area')">
        <p class="survey-title">月派单量统计</p>
        <div class="survey-area" style="width: 280px" id="areaOrderCharts"></div>
      </div>
      <div class="survey" v-show="hasPerm('maintain:monitor:dynamo:mouth:area')">
        <p class="survey-title">月发电量统计</p>
        <div class="survey-area" style="width: 280px" id="areaPowerCharts"></div>
      </div>
    </div>
    <div class="survey-wrapper right-survey" v-if="bankShow">
      <div v-if="!waterFlag">
        <div class="survey">
          <p class="survey-title">站址详情</p>
          <i class="close iconfont icon-check-error" title="关闭" @click="closeBank"></i>
          <el-row class="survey-vehicle bankDetail">
            <el-row class="bank_img">
              <el-image
                v-if="fourShopShow"
                style="width: 280px; height: 150px"
                :src="fourShopDetail.image ||
              require('@/assets/images/defaultUrl/4s.png')
              "
                fit="fill"
              ></el-image>
              <el-image
                v-else-if="bankInfowindowData.type == 13"
                style="width: 280px; height: 150px"
                :src="require('@/assets/images/defaultUrl/' +
              bankInfowindowData.stationId +
              '.png')
              "
                fit="fill"
              ></el-image>
              <el-image
                v-else
                style="width: 280px; height: 150px"
                :src="bankInfowindowData.image ||
              require('@/assets/images/defaultUrl/' +
                bankInfowindowData.type +
                '.png')
              "
                fit="fill"
              ></el-image>
            </el-row>
            <el-row class="bank_name" v-if="fourShopShow">
              <span :title="fourShopDetail_name_type">
                {{
                fourShopDetail_name_type
                }}
              </span>
            </el-row>
            <el-row class="bank_name" v-else>
              {{
              bankInfowindowData.name
              }}
            </el-row>
            <el-row class="bank_message" v-show="bankDetailShow">
              <el-row>
                <span>负责人：</span>
                <span>{{ bankInfowindowData.contacts }}</span>
              </el-row>
              <el-row>
                <span>联系电话：</span>
                <span>{{ bankInfowindowData.phone }}</span>
              </el-row>
              <el-row>
                <span>负载功率：</span>
                <span>{{ bankInfowindowData.loadPower }}</span>
              </el-row>
              <el-row>
                <span>详细地址：</span>
                <span>{{ bankInfowindowData.addr }}</span>
              </el-row>
              <el-row>
                <span>归属区域：</span>
                <span>{{ bankInfowindowData.groupName }}</span>
              </el-row>
              <el-row>
                <span>备注：</span>
                <span>{{ bankInfowindowData.remark }}</span>
              </el-row>
            </el-row>
            <el-row class="bank_message" v-show="baseStationShow">
              <el-row>
                <span>站址编码：</span>
                <span>{{ bankInfowindowData.code }}</span>
              </el-row>
              <el-row>
                <span>基站直流负载：</span>
                <span>{{ bankInfowindowData.dcLoadCurrent }}</span>
              </el-row>
              <el-row>
                <span>详细地址：</span>
                <span>{{ bankInfowindowData.addr }}</span>
              </el-row>
              <el-row>
                <span>备注：</span>
                <span>{{ bankInfowindowData.remark }}</span>
              </el-row>
              <el-row>
                <span>归属区域：</span>
                <span>{{ bankInfowindowData.groupName }}</span>
              </el-row>
            </el-row>
            <el-row class="bank_message" v-show="fourShopShow">
              <el-row>
                <span>联系人：</span>
                <span>{{ fourShopDetail.relationshipName }}</span>
              </el-row>
              <el-row>
                <span>联系电话：</span>
                <span>{{ fourShopDetail.relationshipPhone }}</span>
              </el-row>
              <el-row>
                <span>维修店联系电话：</span>
                <span>{{ fourShopDetail.phone }}</span>
              </el-row>
              <el-row>
                <span>详细地址：</span>
                <span>{{ fourShopDetail.addr }}</span>
              </el-row>
            </el-row>
            <el-button
              v-if="hasPerm('maintain:monitor:order:v3') && !fourShopShow"
              type="primary"
              :disabled="orderDisabled"
              @click.native="dispatchOrder"
            >{{ orderTitle }}</el-button>
          </el-row>
        </div>
        <div class="survey" v-show="!fourShopShow">
          <p class="survey-title">月派单量统计</p>
          <div class="survey-area" id="bankOrderCharts"></div>
        </div>
        <div class="survey" v-show="!fourShopShow">
          <p class="survey-title">月发电量统计</p>
          <div class="survey-area" id="bankPowerCharts"></div>
        </div>
      </div>
      <div v-else>
        <div class="survey">
          <p class="survey-title">站址详情</p>
          <i class="close iconfont icon-check-error" title="关闭" @click="closeBank"></i>
          <el-row class="survey waterDetail">
            <el-row class="bank_message">
              <el-row>
                <span>工单名称：</span>
                <span>{{ waterTestObj.name }}</span>
              </el-row>
              <el-row>
                <span>设备名称：</span>
                <span>{{ waterTestObj.contacts }}</span>
              </el-row>
              <el-row>
                <span>开始时间：</span>
                <span>{{ waterTestObj.addTime }}</span>
              </el-row>
              <el-row>
                <span>结束时间：</span>
                <span>{{ waterTestObj.endTime }}</span>
              </el-row>
              <el-row>
                <span>水温_1：</span>
                <span>{{ waterTestObj.水温_1 }}</span>
              </el-row>
              <el-row>
                <span>PH_1：</span>
                <span>{{ waterTestObj.PH_1}}</span>
              </el-row>
              <el-row>
                <span>氨氮_1：</span>
                <span>{{ waterTestObj.氨氮_1 }}</span>
              </el-row>
              <el-row>
                <span>电导率_1：</span>
                <span>{{ waterTestObj.电导率_1 }}</span>
              </el-row>
              <el-row>
                <span>CODmn_1：</span>
                <span>{{ waterTestObj.CODmn_1 }}</span>
              </el-row>
              <el-row>
                <span>总氮_1：</span>
                <span>{{ waterTestObj.总氮_1 }}</span>
              </el-row>
              <el-row>
                <span>总磷_1：</span>
                <span>{{ waterTestObj.总磷_1 }}</span>
              </el-row>
              <el-row>
                <span>溶解氧_1：</span>
                <span>{{ waterTestObj.溶解氧_1 }}</span>
              </el-row>
              <el-row>
                <span>浊度_1：</span>
                <span>{{ waterTestObj.浊度_1 }}</span>
              </el-row>
            </el-row>
          </el-row>
          <el-row class="survey">
            <p class="survey-title">取水点图片</p>
            <ul class="water-list">
              <li v-for="(src,index) in waterTestDetail.waterPointImageryList" :key="index">
                <el-image
                  :src="src"
                  style="width: 80px;height: 80px"
                  fit="cover"
                  :preview-src-list="waterTestDetail.waterPointImageryList"
                ></el-image>
              </li>
            </ul>
          </el-row>
        </div>
        <div class="survey">
          <p class="survey-title">飞机相机拍摄图片列表</p>
          <ul class="water-list">
            <li v-for="(src,index) in waterTestDetail.cameraImageryList" :key="index">
              <el-image
                :src="src"
                style="width: 80px;height: 80px"
                fit="cover"
                :preview-src-list="waterTestDetail.cameraImageryList"
              ></el-image>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <el-row
      class="survey-wrapper bottom-survey"
      v-show="surveyShow && hasPerm('maintain:monitor:area:proportion')"
    >
      <el-col :span="12" class="survey">
        <p class="survey-title">发电量占比</p>
        <div class="year">{{ year || "2022年" }}</div>
        <div class="survey-area" id="powerScale"></div>
      </el-col>
      <el-col :span="12" class="survey powerTop">
        <p class="survey-title">平均响应时长（TOP5）</p>
        <div class="year">{{ year || "2022年" }}</div>
        <div class="survey-area" id="powerTop"></div>
      </el-col>
    </el-row>
    <div
      class="openRetract"
      v-if="hasPerm('maintain:monitor:area:proportion')"
      @click="surveyShowClick"
      :style="{
      left: surveyShow ? '-805px' : '-805px',
      bottom: surveyShow ? '255px' : '20px',
    }"
    >
      <i
        class="iconfont iconjiantoushang"
        :style="{ transform: surveyShow ? 'rotate(180deg)' : 'rotate(0deg)' }"
      ></i>
    </div>
    <!-- 全屏 -->
    <div class="fullScreen" v-if="fullScreenBtn" @click="fullScreen">
      <span>
        <i class="iconfont iconquanping"></i>
      </span>
      <span>全屏</span>
    </div>
    <div class="switch-survey" :style="{ right: bankShow ? '360px' : '20px' }">
      <div class="fault-switch">
        <p>只显示告警站</p>
        <p>
          <el-switch
            :value="justFault"
            class="switchBtn"
            @click.native="justFault = !justFault"
            @change="switchFaultChange(justFault)"
            active-color="#F4324D"
            inactive-color="#24D85B"
          ></el-switch>
        </p>
      </div>
      <div class="fault-switch">
        <p>只显示发过电站</p>
        <p>
          <el-switch
            :value="!isPower"
            class="switchBtn"
            @click.native="isPower = !isPower"
            @change="switchPowerFaultChange(!isPower)"
            active-color="#F4324D"
            inactive-color="#24D85B"
          ></el-switch>
        </p>
      </div>
      <div class="close-switch">
        <li v-for="item of switchList" :key="item.id" class="switchItem">
          <template v-if="hasPerm(item.limit) && (justFault || item.id != 1 || isPower)">
            <img :src="item.img" />
            <el-switch
              class="switchBtn"
              :value="item.switchStatus"
              @click.native="item.switchStatus = !item.switchStatus"
              @change="switchChange(item)"
              active-color="#F4324D"
              inactive-color="#24D85B"
            ></el-switch>
          </template>
        </li>
      </div>
      <div class="close-switch">
        <li v-for="item in vehicleVersionList" :key="item.id" class="switchItem">
          <img class="imgVehicle" :src="item.img" />
          <el-switch
            class="switchBtnV"
            :value="item.vehicleVersion"
            @click.native="item.vehicleVersion = !item.vehicleVersion"
            @change="switchChangeVersion(item)"
            active-color="#F4324D"
            inactive-color="#24D85B"
          ></el-switch>
        </li>
      </div>
    </div>
    <!-- 高德地图点击车辆标注显示的盒子 -->
    <el-row class="infoWindow" ref="vehicleInfowindow" v-show="vehicleId">
      <i :class="turnLeftOn ? 'delta-left' : 'delta'"></i>
      <el-row
        class="orderTime"
        v-if="
        vehicleInfoWindowData.orderState &&
        vehicleInfoWindowData.orderState != 1
      "
      >
        <el-col :span="8">工单历时</el-col>
        <el-col :span="16">{{ vehicleInfoWindowData.takeTime }}</el-col>
      </el-row>
      <el-row class="infoWindow-detail">
        <el-row class="vehicleStatus">
          <span class="powering" v-if="vehicleInfoWindowData.powerState == 1">发电中</span>
          <span class="fueling" v-if="vehicleInfoWindowData.oilPumpingState == 1">抽油中</span>
          <span class="no-receive" v-if="vehicleInfoWindowData.orderState == 1">未接单</span>
          <span class="routing" v-if="vehicleInfoWindowData.orderState == 2">在途中</span>
          <span class="routing" v-if="vehicleInfoWindowData.orderState == 3">已接单</span>
        </el-row>
        <el-row class="carNumber">{{ vehicleInfoWindowData.plateNum }}</el-row>
        <el-row>{{ vehicleInfoWindowData.name }}</el-row>
        <el-row>{{ vehicleInfoWindowData.phone }}</el-row>
        <el-row>
          <span>剩余油量：</span>
          <span>{{ vehicleInfoWindowData.adFuel + "L" }}</span>
        </el-row>
        <el-row>
          <span>当前车速：</span>
          <span>{{ vehicleInfoWindowData.absVehicleSpeed }}KM/H</span>
        </el-row>
        <el-row v-if="vehicleInfoWindowData.powerState == 1">
          <el-row>
            <span>发电功率：</span>
            <span>{{ vehicleInfoWindowData.forwardPower }}W</span>
          </el-row>
          <el-row>
            <span>发电时长：</span>
            <span>{{ vehicleInfoWindowData.duration }}</span>
          </el-row>
          <el-row>
            <span>发电量：</span>
            <span>{{ vehicleInfoWindowData.capacity }}KW·H</span>
          </el-row>
        </el-row>
        <el-row v-if="bankRoute">
          <!-- <el-row v-if="(vehicleInfoWindowData.orderState == 2&&vehicleInfoWindowData.powerState != 1) || bankRoute"> -->
          <el-row>
            <span>预计行程：</span>
            <span>{{ drivingRoutel }}</span>
          </el-row>
          <el-row>
            <span>预计用时：</span>
            <span>{{ drivingTime }}</span>
          </el-row>
        </el-row>
      </el-row>
      <span
        :class="turnLeftOn ? 'checkDetail-left' : 'checkDetail'"
        @click="getVehicleDetail(vehicleInfoWindowData)"
        v-if="hasPerm('maintain:monitor:vehicle:details:v3')"
      >查看详情</span>
      <el-button
        :class="turnLeftOn ? 'direction-right' : 'direction-left'"
        type="primary"
        :icon="turnLeftOn ? 'el-icon-caret-right' : 'el-icon-caret-left'"
        @click="turnDirection"
      ></el-button>
    </el-row>
    <!-- 高德地图点击站址未回单的盒子 -->
    <el-row
      class="infoWindow baseStationInfowindow"
      ref="baseStationInfowindow"
      v-show="baseStationId"
    >
      <i class="delta"></i>
      <el-row class="infoWindow-detail">
        <el-row class="receipTitle">未回单车辆</el-row>
        <el-col v-for="item of receipVehicle" :key="item.vin">
          <el-button
            type="text"
            size="small"
            @click.native="toVehicleLnglat(item.lonlat)"
          >{{ item.plate }}</el-button>
        </el-col>
      </el-row>
    </el-row>
    <div class="orderDesc" v-show="orderShow">
      <div>{{ orderDesc.message }}</div>
      <p>{{ time }}</p>
    </div>
    <!--新增工单-->
    <el-dialog title="派单" :visible.sync="addOrderVisible" class="mini-dialog" width="625px">
      <el-form :rules="rules" ref="orderForm" :model="orderForm" size="mini" :inline="true">
        <el-form-item prop="type" label="工单类型">
          <el-select
            v-model="orderForm.type"
            @change="changeType"
            clearable
            placeholder="请选择工单类型"
            style="width: 465px"
          >
            <el-option
              v-for="item in orderType"
              :key="item.code"
              :label="item.value"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="is-required" label="停电时间" v-if="flag">
          <date-picker
            style="width: 465px"
            :startTime="orderFormStartTime"
            :endTime="orderFormEndTime"
            :startText="'计划停电开始时间'"
            :endText="'计划停电结束时间'"
            @changeStart="changeStart"
            @changeEnd="changeEnd"
          ></date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addOrderVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveOrUpdate">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 点击派单量，发电量弹窗 -->
    <el-dialog :title="chartTitle" :visible.sync="dialogVisible" width="1200px">
      <el-row>
        <el-row>
          <el-date-picker
            size="small"
            v-model="chartVal"
            type="month"
            format="yyyy 年 MM 月"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择月份"
          ></el-date-picker>
          <el-button type="primary" style="margin-left: 20px" @click="queryCharts">查询</el-button>
        </el-row>
        <el-row>
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="派单量统计" name="first">
              <el-row class="bigCharts" id="bigChartsOne"></el-row>
            </el-tab-pane>
            <el-tab-pane label="发电量统计" name="second">
              <el-row class="bigCharts" id="bigChartsTwo"></el-row>
            </el-tab-pane>
            <el-tab-pane label="工单记录" name="third">
              <el-table
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                size="mini"
                stripe
                height="468px"
                @row-click="handleClickTableRow"
              >
                <el-table-column type="selection" width="24" align="center" style="padding: 0"></el-table-column>
                <el-table-column type="index" label="序号" width="45"></el-table-column>
                <el-table-column prop="subjectNum" label="工单编号" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="type" label="工单类型">
                  <template slot-scope="scope">
                    <span v-if="scope.row.type == 1">计划发电</span>
                    <span v-if="scope.row.type == 2">应急发电</span>
                  </template>
                </el-table-column>
                <el-table-column prop="stationName" width="180" label="站址名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="dispatchName" label="派单人员" show-overflow-tooltip></el-table-column>
                <el-table-column prop="dispatchTime" width="150" label="派单时间" show-overflow-tooltip></el-table-column>
                <el-table-column prop="receiveName" label="接单人员" show-overflow-tooltip></el-table-column>
                <el-table-column prop="receiveTime" label="接单时间" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="takeTime" width="120" label="工单历时" show-overflow-tooltip></el-table-column>
                <el-table-column label="操作" width="100" fixed="right">
                  <template slot-scope="scope">
                    <el-button size="mini" type="text" @click.stop="getOrderInfo(scope.row)">详情</el-button>
                    <el-button
                      size="mini"
                      type="text"
                      v-if="scope.row.receiveState == 3"
                      @click.stop="getStatistics(scope.row)"
                    >统计</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-size="limit"
                layout="total, prev, pager, next, jumper"
                :total="total"
              ></el-pagination>
            </el-tab-pane>
          </el-tabs>
        </el-row>
      </el-row>
    </el-dialog>
    <!-- 工单统计 -->
    <el-dialog title="工单统计" :visible.sync="StatisticsVisible" class="mini-dialog receipt-info">
      <el-row :gutter="20">
        <el-col :span="6" class="dialog-label">工单历时</el-col>
        <el-col :span="18">{{ $judgeEmpty(StatisticsInfo.takeTime) }}</el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6" class="dialog-label">发电量</el-col>
        <el-col :span="18">{{ $judgeEmpty(StatisticsInfo.power) }}</el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6" class="dialog-label">发电时长</el-col>
        <el-col :span="18">{{ $judgeEmpty(StatisticsInfo.powerTime) }}</el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6" class="dialog-label">发电油耗</el-col>
        <el-col :span="18">{{ $judgeEmpty(StatisticsInfo.powerOil) }}</el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6" class="dialog-label">平均油耗</el-col>
        <el-col :span="18">{{ $judgeEmpty(StatisticsInfo.averageOil) }}</el-col>
      </el-row>
    </el-dialog>
    <!-- 详情弹窗 -->
    <el-dialog title="详情" :visible.sync="infoVisible" class="mini-dialog info-box">
      <div class="con-left">
        <p class="dialog-title">工单信息</p>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">工单编号</el-col>
          <el-col :span="18">
            {{
            $judgeEmpty(detailsInfoData.subjectNum)
            }}
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">工单类型</el-col>
          <el-col :span="18">{{ $judgeEmpty(detailsInfoData.type) }}</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">工单状态</el-col>
          <el-col :span="18">
            {{
            $judgeEmpty(detailsInfoData.receiveState)
            }}
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">工单内容</el-col>
          <el-col :span="18" :title="$judgeEmpty(detailsInfoData.content)" class="text-overflow">
            {{
            $judgeEmpty(detailsInfoData.content) }}
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">派单人员</el-col>
          <el-col :span="18">
            {{
            $judgeEmpty(detailsInfoData.dispatchName)
            }}
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">接单人员</el-col>
          <el-col
            :span="18"
            :title="$judgeEmpty(detailsInfoData.receiveName)"
            class="text-overflow"
          >
            {{
            $judgeEmpty(detailsInfoData.receiveName) }}
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">联系电话</el-col>
          <el-col :span="18" :title="$judgeEmpty(detailsInfoData.phone)" class="text-overflow">
            {{
            $judgeEmpty(detailsInfoData.phone) }}
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">车架号</el-col>
          <el-col :span="18" :title="$judgeEmpty(detailsInfoData.vin)" class="text-overflow">
            {{
            $judgeEmpty(detailsInfoData.vin) }}
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">车牌号</el-col>
          <el-col :span="18" :title="$judgeEmpty(detailsInfoData.platNum)" class="text-overflow">
            {{
            $judgeEmpty(detailsInfoData.platNum) }}
          </el-col>
        </el-row>
      </div>
      <div class="con-right">
        <p class="dialog-title">站址信息</p>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">站址名称</el-col>
          <el-col :span="18">
            {{
            $judgeEmpty(stationInfoData.stationName)
            }}
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">站址编码</el-col>
          <el-col :span="18">{{ $judgeEmpty(stationInfoData.code) }}</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">经度</el-col>
          <el-col :span="18">
            {{
            $judgeEmpty(stationInfoData.longitude)
            }}
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">纬度</el-col>
          <el-col :span="18">
            {{
            $judgeEmpty(stationInfoData.latitude)
            }}
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">基站直流负载（A）</el-col>
          <el-col :span="18">
            {{
            $judgeEmpty(stationInfoData.dcLoadCurrent)
            }}
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">详细地址</el-col>
          <el-col :span="18">{{ $judgeEmpty(stationInfoData.addr) }}</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">备注</el-col>
          <el-col :span="18">{{ $judgeEmpty(stationInfoData.remark) }}</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">归属分组</el-col>
          <el-col :span="18">
            {{
            $judgeEmpty(stationInfoData.areaName)
            }}
          </el-col>
        </el-row>
      </div>
      <div>
        <p class="dialog-title">工单进度</p>
        <div class="time-wrap">
          <span class="time-box">
            <span class="time-label">计时</span>
            <span class="time-con">
              {{
              $judgeEmpty(infoData.totalTakeTime)
              }}
            </span>
          </span>
        </div>
        <order-step :orderInfoData="orderInfoData" :step="step"></order-step>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import AMap from "AMap";
import DatePicker from "@/components/DatePicker.vue";
import OrderStep from "../../../components/OrderStep.vue";
import { setInterval, clearInterval } from "timers";
export default {
  components: {
    DatePicker,
    OrderStep
  },
  name: "monitor",
  data() {
    return {
      restaurants: [],
      timeout: null,
      queryForm: {
        plateNum: "",
        name: ""
      },
      errorShow: false,
      normalShow: true,
      searchData: "",
      companyName: null,
      drivingRoutelM: null,
      fourShopDetail: {},
      errorStatus: null,
      bankDetailShow: false,
      baseStationShow: false,
      fourShopShow: false,
      websockTimer: null,
      step: [],
      orderInfoData: [],
      detailsInfoData: {},
      stationInfoData: {},
      infoVisible: false,
      infoData: {},
      StatisticsInfo: {},
      StatisticsVisible: false,
      loading: false,
      timer: null,
      orderTimer: null,
      refreshTime: "",
      monitorLnglat: [],
      tableData: [],
      currentPage: 1,
      limit: 8,
      total: 0,
      activeName: "first",
      chartTitle: "数据统计详情",
      chartVal: null,
      dialogVisible: false,
      orderTitle: "派单",
      time: null,
      orderDisabled: false,
      orderShow: false,
      orderDesc: {},
      websock: null,
      scale: null,
      justFault: false,
      isPower: false,
      monitorData: {
        refreshTime: "",
        order: {},
        station: {},
        vehicle: {}
      },
      bankRoute: false,
      vehicleTotalNum: "",
      dynamoList: [],
      timeListx: [],
      timeListy: [],
      areaOrderDatax: [],
      areaOrderDatay: [],
      areaPowerDatax: [],
      areaPowerDatay: [],
      areaPowerDatayT: [],
      powerDatax: [],
      powerDatay: [],
      orderDatax: [],
      orderDatay: [],
      fourShopData: [],
      fourShopMarks: null,
      vehicleLocal: {},
      vehicleMarker: [],
      vehicleMarkerList: [],
      varMarker: "",
      // oilStateMarker: "",
      powerStateMarker: "",
      vin: "",
      deptId: "",
      vehicleInfoWindow: null, // 车辆信息窗体
      vehicleInfoWindowData: {},
      vehicleId: false,
      baseStationInfoWindow: null, // 基站信息窗体
      baseStationInfoWindowData: {},
      baseStationId: false,
      vehicleInfoSwitch: true,
      drivingRoutel: "",
      drivingTime: "",
      checkedBank: "",
      bsData: {},
      bankData: {}, //银行
      errorBSMarkers: [], //基站
      BSMarkers: [],
      errorBSMarks: null,
      BSMarks: null,
      BsUrl: require("@/assets/images/monitor/baseStation.png"),
      faultBsUrl: require("@/assets/images/monitor/faultBaseStation.png"),
      errorABOCMarkers: [], //农行
      ABOCMarkers: [],
      errorABOCMarks: null,
      ABOCMarks: null,
      ABOCUrl: require("@/assets/images/monitor/bank/ABOC.png"),
      faultABOCUrl: require("@/assets/images/monitor/bank/ABOC_error.png"),
      errorICBCMarkers: [], //工行
      ICBCMarkers: [],
      errorICBCMarks: null,
      ICBCMarks: null,
      ICBCUrl: require("@/assets/images/monitor/bank/ICBC.png"),
      faultICBCUrl: require("@/assets/images/monitor/bank/ICBC_error.png"),
      errorBOCMarkers: [], //中行
      BOCMarkers: [],
      errorBOCMarks: null,
      BOCMarks: null,
      BOCUrl: require("@/assets/images/monitor/bank/BOC.png"),
      faultBOCUrl: require("@/assets/images/monitor/bank/BOC_error.png"),
      errorCCBMarkers: [], //建行
      CCBMarkers: [],
      errorCCBMarks: null,
      CCBMarks: null,
      CCBUrl: require("@/assets/images/monitor/bank/CCB.png"),
      faultCCBUrl: require("@/assets/images/monitor/bank/CCB_error.png"),
      errorBCMarkers: [], //交行
      BCMarkers: [],
      errorBCMarks: null,
      BCMarks: null,
      BCUrl: require("@/assets/images/monitor/bank/BC.png"),
      faultBCUrl: require("@/assets/images/monitor/bank/BC_error.png"),
      errorZSHMarkers: [], //中石化
      ZSHMarkers: [],
      errorZSHMarks: null,
      ZSHMarks: null,
      ZSHUrl: require("@/assets/images/monitor/bank/ZSH.png"),
      faultZSHUrl: require("@/assets/images/monitor/bank/ZSH_error.png"),
      errorCNPCMarkers: [], //中石油
      CNPCMarkers: [],
      errorCNPCMarks: null,
      CNPCMarks: null,
      CNPCUrl: require("@/assets/images/monitor/bank/CNPC.png"),
      faultCNPCUrl: require("@/assets/images/monitor/bank/CNPC_error.png"),
      errorCZBMarkers: [], //浙商银行
      CZBMarkers: [],
      errorCZBMarks: null,
      CZBMarks: null,
      CZBUrl: require("@/assets/images/monitor/bank/CZB.png"),
      faultCZBUrl: require("@/assets/images/monitor/bank/CZB_error.png"),
      errorHXMarkers: [], //华夏银行
      HXMarkers: [],
      errorHXMarks: null,
      HXMarks: null,
      HXUrl: require("@/assets/images/monitor/bank/HX.png"),
      faultHXUrl: require("@/assets/images/monitor/bank/HX_error.png"),
      errorYZMarkers: [], //邮政银行
      YZMarkers: [],
      errorYZMarks: null,
      YZMarks: null,
      YZUrl: require("@/assets/images/monitor/bank/YZ.png"),
      faultYZUrl: require("@/assets/images/monitor/bank/YZ_error.png"),
      errorZXMarkers: [], //中信银行
      ZXMarkers: [],
      errorZXMarks: null,
      ZXMarks: null,
      ZXUrl: require("@/assets/images/monitor/bank/ZX.png"),
      faultZXUrl: require("@/assets/images/monitor/bank/ZX_error.png"),
      errorAGMarkers: [], // 亚运会
      AGMarkers: [],
      errorAGMarks: null,
      AGMarks: null,
      AGUrl: require("@/assets/images/monitor/bank/AG.png"),
      faultAGUrl: require("@/assets/images/monitor/bank/AG_error.png"),
      errorUNIMarkers: [], // 联通通信
      UNIMarkers: [],
      errorUNIMarks: null,
      UNIMarks: null,
      UNIUrl: require("@/assets/images/monitor/baseStation.png"),
      faultUNIUrl: require("@/assets/images/monitor/faultBaseStation.png"),
      errorMOBMarkers: [], // 移动通信
      MOBMarkers: [],
      errorMOBMarks: null,
      MOBMarks: null,
      MOBUrl: require("@/assets/images/monitor/baseStation.png"),
      faultMOBUrl: require("@/assets/images/monitor/faultBaseStation.png"),
      errorMSMarkers: [], // 民生银行
      MSMarkers: [],
      errorMSMarks: null,
      MSMarks: null,
      MSUrl: require("@/assets/images/monitor/bank/MS.png"),
      faultMSUrl: require("@/assets/images/monitor/bank/MS_error.png"),
      errorCMBMarkers: [], // 招商银行
      CMBMarkers: [],
      errorCMBMarks: null,
      CMBMarks: null,
      CMBUrl: require("@/assets/images/monitor/bank/CMB.png"),
      faultCMBUrl: require("@/assets/images/monitor/bank/CMB_error.png"),
      addOrderVisible: false,
      flag: false,
      orderFormStartTime: "",
      orderFormEndTime: "",
      orderForm: {
        errorId: "",
        type: ""
      },
      rules: {
        type: [
          {
            required: true,
            trigger: "change",
            message: "请选择工单类型"
          }
        ],
        errorId: [
          {
            required: true,
            trigger: "change",
            message: "请选择故障内容"
          }
        ]
      },
      orderType: [
        {
          code: 1,
          value: "计划发电"
        },
        {
          code: 2,
          value: "应急发电"
        }
      ],
      vehicleVersionStatus: true,
      vehicleVersionStatus2: true, // 2.0 车辆
      vehicleType: 1, // 默认只显示 1.0 车辆
      vehicleVersionList: [
        {
          id: 1,
          img: require("@/assets/images/monitor/car-online-45.png"),
          vehicleVersion: false
        },
        {
          id: 2,
          img: require("@/assets/images/monitor/car-online-2-45.png"),
          vehicleVersion: false
        }
      ],
      switchList: [
        // 正常基站
        {
          id: 1,
          type: 1,
          img: require("@/assets/images/monitor/switch/bs.png"),
          switchStatus: true,
          limit: "maintain:monitor:station:display"
        },
        // 告警基站
        {
          id: 0,
          type: 100,
          img: require("@/assets/images/monitor/switch/errorBs.png"),
          switchStatus: false,
          limit: "maintain:monitor:station:display"
        },
        {
          id: 2,
          type: 0,
          img: require("@/assets/images/monitor/switch/4s.png"),
          switchStatus: true,
          limit: "maintain:monitor:4s:display"
        },
        {
          id: 3,
          type: 2,
          img: require("@/assets/images/monitor/switch/aboc.png"),
          switchStatus: false,
          limit: "maintain:monitor:abc:display"
        },
        {
          id: 4,
          type: 3,
          img: require("@/assets/images/monitor/switch/icbc.png"),
          switchStatus: false,
          limit: "maintain:monitor:icbc:display"
        },
        {
          id: 5,
          type: 4,
          img: require("@/assets/images/monitor/switch/boc.png"),
          switchStatus: false,
          limit: "maintain:monitor:bc:display"
        },
        {
          id: 6,
          type: 5,
          img: require("@/assets/images/monitor/switch/ccb.png"),
          switchStatus: false,
          limit: "maintain:monitor:ccb:display"
        },
        {
          id: 7,
          type: 6,
          img: require("@/assets/images/monitor/switch/bc.png"),
          switchStatus: false,
          limit: "maintain:monitor:bcc:display"
        },
        {
          id: 8,
          type: 7,
          img: require("@/assets/images/monitor/switch/zsh.png"),
          switchStatus: false,
          limit: "maintain:monitor:sinopec:display"
        },
        {
          id: 9,
          type: 8,
          img: require("@/assets/images/monitor/switch/cnpc.png"),
          switchStatus: false,
          limit: "maintain:monitor:cnpc:display"
        },
        {
          id: 10,
          type: 9,
          img: require("@/assets/images/monitor/switch/czb.png"),
          switchStatus: false,
          limit: "maintain:monitor:czb:display"
        },
        {
          id: 11,
          type: 10,
          img: require("@/assets/images/monitor/switch/hx.png"),
          switchStatus: false,
          limit: "maintain:monitor:hxb:display"
        },
        {
          id: 12,
          type: 11,
          img: require("@/assets/images/monitor/switch/yz.png"),
          switchStatus: false,
          limit: "maintain:monitor:psbc:display"
        },
        {
          id: 13,
          type: 12,
          img: require("@/assets/images/monitor/switch/zx.png"),
          switchStatus: false,
          limit: "maintain:monitor:citicbank:display"
        },
        {
          id: 14,
          type: 13,
          img: require("@/assets/images/monitor/switch/ag.png"),
          switchStatus: false,
          limit: "maintain:monitor:ag:display"
        },
        {
          id: 15,
          type: 14,
          img: require("@/assets/images/monitor/switch/unicom.png"),
          switchStatus: false,
          limit: "maintain:monitor:unicom:display"
        },
        {
          id: 16,
          type: 15,
          img: require("@/assets/images/monitor/switch/mobile.png"),
          switchStatus: false,
          limit: "maintain:monitor:mobile:display"
        },
        {
          id: 17,
          type: 16,
          img: require("@/assets/images/monitor/switch/ms.png"),
          switchStatus: false,
          limit: "maintain:monitor:msbank:display"
        },
        {
          id: 18,
          type: 17,
          img: require("@/assets/images/monitor/switch/cmb.png"),
          switchStatus: false,
          limit: "maintain:monitor:cmbbank:display"
        }
      ],
      drawOK: true,
      colorArr: [],
      year: "",
      onlineCharts: "",
      offlineCharts: "",
      powerCharts: "",
      areaOrderCharts: "",
      areaPowerCharts: "",
      bigChartsOne: "",
      bigChartsTwo: "",
      powerScale: "",
      powerTop: "",
      bankOrderCharts: "",
      bankPowerCharts: "",
      map: null,
      bankShow: false,
      stationId: null,
      surveyShow: true,
      surveyLeftShow: true,
      bankInfowindowData: {},
      routeLine: null,
      driving: null,
      chartTime: null,
      plateNumMarker: null,
      months: null,
      timeDay: null,
      bankType: null,
      drivingRoutelVin: null,
      stationVehicleId: null,
      fullScreenBtn: true,
      locationError: false,
      receipVehicle: [],
      turnLeftOn: false,
      waterFlag: false,
      waterTestDetail: [],
      waterTestObj: {}
    };
  },
  beforeRouteEnter(to, from, next) {
    // ...
    if (from.name == "VehicleInfo") {
      sessionStorage.setItem("detailPosition", from.params.detailPosition);
    } else {
      sessionStorage.removeItem("detailPosition");
    }
    next();
  },
  beforeRouteLeave(to, from, next) {
    if (to.path == "/VehicleInfo") {
      let path = from.path; //path为定义的变量，不是vue的data定义的变量，当前生命周期data还未初始化
      sessionStorage.setItem("pathUrl", path);
      sessionStorage.setItem("monitorLnglat", this.monitorLnglat);
    } else {
      sessionStorage.removeItem("monitorLnglat");
      sessionStorage.removeItem("detailPosition");
    }
    next();
  },
  computed: {
    // 控制1.0和2.0车辆显示
    statusChange() {
      return [this.vehicleVersionStatus, this.vehicleVersionStatus2];
    },
    // 控制详情名称显示
    fourShopDetail_name_type() {
      let value = this.fourShopDetail.storeType;
      switch (value) {
        case 1:
          return this.fourShopDetail.name + "（4S店）";
        case 2:
          return this.fourShopDetail.name + "（二级维修店）";
        case 3:
          return this.fourShopDetail.name + "（三级维修店）";
        default:
          return this.fourShopDetail.name;
      }
    }
  },
  watch: {
    statusChange: {
      handler(val) {
        if (val[0] && val[1]) {
          // 全部显示
          this.vehicleType = 0;
        }
        if (val[0] && !val[1]) {
          // 显示 1.0
          this.vehicleType = this.$options.data().vehicleType;
        }
        if (!val[0] && val[1]) {
          // 显示 2.0
          this.vehicleType = 2;
        }
        if (!val[0] && !val[1]) {
          // 全部不显示
          this.vehicleType = 3;
        }
        if (!val[0] || !val[1]) {
          this.$nextTick(() => {
            if (this.routeLine) {
              this.driving.clear();
              this.map.remove(this.routeLine);
              this.routeLine = null;
            }
            if (this.vehicleInfoWindow) {
              this.vehicleInfoWindow.hide();
            }
          });
        }
        this.getVehicleLocation();
      },
      immediate: true,
      deep: true
    },
    turnLeftOn(val) {
      if (val) {
        // 车辆信息窗体
        this.vehicleInfoWindow = new AMap.Marker({
          map: this.map,
          content: this.$refs.vehicleInfowindow.$el,
          zIndex: 300,
          anchor: "top-right",
          offset: new AMap.Pixel(-50, -40)
        });
      } else {
        this.vehicleInfoWindow = new AMap.Marker({
          map: this.map,
          content: this.$refs.vehicleInfowindow.$el,
          zIndex: 300,
          anchor: "top-left",
          offset: new AMap.Pixel(30, -40)
        });
      }
      this.vehicleInfoWindow.setPosition(this.vehicleInfoWindowData.lnglat);
    }
  },
  created() {
    // 全屏按钮
    let fullUrl = this.$route.path;
    this.fullScreenBtn = fullUrl == "/fullScreenMonitor" ? false : true;
    // 只显示告警站开关
    let justFault = sessionStorage.getItem("justFault");
    this.justFault = justFault == "false" ? true : false;
    this.bsAndBankStatus();
    this.initWebSocket();
    this.getCurrentTime();
    if (fullUrl == "/monitor") {
      sessionStorage.removeItem("monitorLnglat");
      // 从工单管理跳转全屏之后再切换到运行监控页面需要清除车辆定位效果
      sessionStorage.setItem("isSearch", false);
    }
    this.addWaterMarkers();
  },
  mounted() {
    this.companyName = sessionStorage.getItem("companyName");
    this.surveyShow =
      sessionStorage.getItem("surveyShow") == "false" ? false : true;
    this.surveyLeftShow =
      sessionStorage.getItem("surveyLeftShow") == "false" ? false : true;
    this.initMap();
    this.refreshMonitorData();
    this.getVehicleLocation().then(() => {
      this.restaurants = this.vehicleLocal;
      let plate = sessionStorage.getItem("fullMonitorPlate");
      // 控制是否使用搜索车辆定位并且显示车辆信息窗体
      let isSearch =
        sessionStorage.getItem("isSearch") == "false" ? false : true;
      if (plate && isSearch) {
        this.searchVehicle(0, plate);
      }
    });
    if (this.hasPerm("maintain:monitor:order:mouth:area")) {
      this.getAreaOrderCharts("areaOrderCharts");
    }
    if (this.hasPerm("maintain:monitor:dynamo:mouth:area")) {
      this.getAreaPowerCharts("areaPowerCharts");
    }
    if (this.hasPerm("maintain:monitor:4s:display")) {
      this.getFourShopData();
    }
    if (this.hasPerm("maintain:monitor:area:proportion")) {
      this.getPowerScaleCharts();
      this.initPowerScaleCharts();
      this.initPowerTopCharts();
    }
    // sessionStorage.removeItem('bankLnglat')
  },
  methods: {
    // 监测点
    async addWaterMarkers() {
      let { data: res } = await this.$axios.get(
        "/api/water/detection/waterList"
      );
      if (res.code !== 1) {
        return;
      } else {
        let mkIcon = new AMap.Icon({
          size: new AMap.Size(26, 38),
          image: require("@/assets/images/geological/monitorStation.png"),
          imageSize: new AMap.Size(26, 38) // 图标取图偏移量
        });
        let markerInfo = res.data;
        let l = markerInfo.length;
        let markerList = [];
        let markerBase = null;
        for (let i = 0; i < l; i++) {
          markerBase = new AMap.Marker({
            icon: mkIcon,
            anchor: "bottom-center",
            position: [markerInfo[i].longitude, markerInfo[i].latitude],
            offset: new AMap.Pixel(2, 0) // 设置点标记偏移量
          });
          // 将车辆信息添加到事件回调参数中【添加到事件回调参数的content属性上】
          markerBase.content = markerInfo[i];
          // 监听点击标记点事件
          AMap.event.addListener(markerBase, "click", e => {
            let location = [
              e.target.content.longitude,
              e.target.content.latitude
            ];
            // 点击显示标记点选中状态
            this.checkedBank.setPosition(location);
            this.map.add(this.checkedBank);
            // 通过传递该点击的标记点参数数据得到该车辆的详细信息
            this.waterTestDetail = e.target.content;
            this.waterTestObj = this.handleWaterTestInfo(e.target.content);
            // 显示详情框
            this.bankShow = true;
            this.waterFlag = true;
            // this.map.setFitView();
            // this.map.setCenter(e.target.content.location);
          });
          markerList.push(markerBase);
          this.map.add(markerList);
        }
      }
    },
    // 处理水质监测数据
    handleWaterTestInfo(item) {
      let newList = [];
      newList = item.list.map(ele => {
        return {
          [ele.sensorname]: `${ele.value}${ele.unit}`
        };
      });
      let mergedSensors = Object.assign({}, ...newList);
      return { ...item, ...mergedSensors };
    },
    querySearchAsync(queryString, cb) {
      let restaurants = this.restaurants;
      let results = queryString
        ? restaurants.filter(this.createStateFilter(queryString))
        : restaurants;
      results.map(item => {
        return (item.value = item.plateNum + "(" + item.name + ")");
      });
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 3000 * Math.random());
    },
    createStateFilter(queryString) {
      return restaurant => {
        let restaurants =
          restaurant.plateNum
            .toLowerCase()
            .indexOf(queryString.toLowerCase()) !== -1 ||
          restaurant.name.toLowerCase().indexOf(queryString.toLowerCase()) !==
            -1;
        return restaurants;
      };
    },
    // 点击搜索车辆
    searchVehicle(e, plate) {
      let queryFlag = false;
      let data = this.vehicleLocal;
      queryFlag = false;
      if (plate) {
        this.searchData = String(plate);
      }
      if (this.searchData == "") {
        this.errorShow = true;
        this.normalShow = false;
        setTimeout(() => {
          this.errorShow = false;
          this.normalShow = true;
        }, 200);
        queryFlag = false;
        return;
      }
      data.find(item => {
        if (e == 0) {
          // 跳转得到的车牌号
          // 解决刷新页面车辆定位问题
          sessionStorage.removeItem("fullMonitorPlate");
          if (item.plateNum === this.searchData) {
            queryFlag = true;
            this.vin = item.vin;
            this.deptId = item.deptId;
            this.map.setCenter(item.lnglat);
          }
        } else {
          // 搜索得到的车牌号或者车辆绑定人
          if (
            item.name === this.searchData.split("(")[1] ||
            item.plateNum === this.searchData.split("(")[0]
          ) {
            queryFlag = true;
            this.vin = item.vin;
            this.deptId = item.deptId;
            this.map.setCenter(item.lnglat);
          }
        }
      });

      if (queryFlag) {
        this.monitorVehicleMarkerEvent(this.vin, this.deptId);
      } else {
        // this.vehicleInfoWindow.hide();
        this.$message.warning("未找到对应车辆或人员!");
      }
    },
    // 点击未回单车牌号跳转车辆位置
    toVehicleLnglat(lnglat) {
      this.map.setCenter(lnglat);
    },
    surveyShowClick() {
      this.surveyShow = !this.surveyShow;
      sessionStorage.setItem("surveyShow", this.surveyShow);
    },
    surveyLeftShowClick() {
      this.surveyLeftShow = !this.surveyLeftShow;
      sessionStorage.setItem("surveyLeftShow", this.surveyLeftShow);
    },
    // 站址状态判断，请求
    bsAndBankStatus() {
      if (this.hasPerm("maintain:monitor:station:v3")) {
        //当前账户有权限
        // 页面重新刷新后默认隐藏正常基站
        let bsStationStatus = sessionStorage.getItem("type1");
        if (bsStationStatus == "false") {
          this.BSMarks && this.BSMarks.clear();
          this.switchList[0].switchStatus = true;
          sessionStorage.setItem("type1", true);
        }
        this.switchList.forEach(item => {
          // 获取站址当前开关状态
          let isStatus = sessionStorage.getItem("type" + item.type);
          if (isStatus) {
            //有站址状态改变了
            item.switchStatus = isStatus == "true" ? true : false;
          }
          if (!item.switchStatus) {
            //判断站址开关状态，打开时调用
            if (item.type == 0) return;
            //4s店除外
            if (item.type == 1) {
              //正常基站
              this.getBSData(1, 1);
            } else {
              //故障基站
              if (item.type == 100) {
                this.getBSData(1);
              } else {
                if (this.justFault) {
                  // 关闭只显示告警银行按钮需要添加正常银行标记点
                  this.getBankData(item.type, 1);
                }
                this.getBankData(item.type);
              }
            }
          }
        });
      }
    },
    // 全屏
    fullScreen() {
      const { href } = this.$router.resolve({
        path: "/fullScreenMonitor"
      });
      window.open(href, "_blank");
    },
    //列表详情弹窗内容
    async getOrderInfo(rowData) {
      let id = rowData.id;
      this.step = [];
      //显示弹框
      this.infoVisible = true;
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/v2/order/manage/info/" + id
      );
      if (res.code == 1) {
        this.infoData = res.data;
        this.orderInfoData = res.data.schedules;
        this.detailsInfoData = res.data.details;
        this.stationInfoData = res.data.station;
        this.detailsInfoData.receiveState =
          this.detailsInfoData.receiveState == "1"
            ? "待接单"
            : this.detailsInfoData.receiveState == "2"
            ? "已接单"
            : "已回单";
        this.detailsInfoData.type =
          this.detailsInfoData.type == 1 ? "计划发电" : "应急发电";
        for (let i = 0; i < this.orderInfoData.length; i++) {
          if (this.orderInfoData[i].receiptTime) {
            this.step.push(5);
          } else if (this.orderInfoData[i].powerEndTime) {
            this.step.push(4);
          } else if (this.orderInfoData[i].powerStartTime) {
            this.step.push(3);
          } else if (this.orderInfoData[i].receiveTime) {
            this.step.push(2);
          } else if (this.orderInfoData[i].dispatchTime) {
            this.step.push(1);
          }
        }
      } else {
        _this.$message.warning(res.msg);
      }
    },
    // 工单统计
    async getStatistics(rowData) {
      this.StatisticsVisible = true;
      let _this = this;
      let orderNum = rowData.subjectNum;
      let { data: res } = await _this.$axios.get(
        "/api/order/manage/receipt/count/" + orderNum
      );
      if (res.code == 1) {
        _this.StatisticsInfo = res.data;
        if (_this.StatisticsInfo.averageOil != "") {
          _this.StatisticsInfo.averageOil =
            _this.StatisticsInfo.averageOil + "L/H";
        }
        if (_this.StatisticsInfo.power != "") {
          _this.StatisticsInfo.power = _this.StatisticsInfo.power + "KW·H";
        }
        if (_this.StatisticsInfo.powerOil != "") {
          _this.StatisticsInfo.powerOil = _this.StatisticsInfo.powerOil + "L";
        }
      } else {
        _this.$message.warning(res.msg);
      }
    },
    getCurrentTime() {
      this.timer = setInterval(() => {
        let dateTime;
        const yy = new Date().getFullYear();
        const mm =
          new Date().getMonth() + 1 < 10
            ? "0" + (new Date().getMonth() + 1)
            : new Date().getMonth() + 1;
        const dd =
          new Date().getDate() < 10
            ? "0" + new Date().getDate()
            : new Date().getDate();
        const hh = new Date().getHours();
        const mf =
          new Date().getMinutes() < 10
            ? "0" + new Date().getMinutes()
            : new Date().getMinutes();
        const ss =
          new Date().getSeconds() < 10
            ? "0" + new Date().getSeconds()
            : new Date().getSeconds();
        dateTime = yy + "-" + mm + "-" + dd + " " + hh + ":" + mf + ":" + ss;
        this.refreshTime = dateTime;
      }, 1000);
    },
    // 点击工单概况跳转相应状态的工单
    goToOrder(data) {
      this.$router.push({
        name: "Dispatch",
        params: {
          id: data
        }
      });
      this.$store.state.MenuStore.menu_path = "工单管理 > 派单管理";
    },
    // 点击车辆概况跳转相应状态的车辆
    goToVehicle(type) {
      if (this.hasPerm("maintain:monitor:vehicle:v3")) {
        this.getVehicleVersion(type);
        this.$store.state.MenuStore.menu_path = "车辆管理 > 车辆管理";
      } else {
        return;
      }
    },
    async getVehicleVersion(type) {
      let obj = {};
      if (type == 3) {
        obj.powerStatus = 1;
        obj.onlineStatus = "";
      } else {
        obj.powerStatus = "";
        obj.onlineStatus = type == "undefined" ? "" : type;
      }
      let res = await this.$axios.get("/api/vehicle/vehicleVersion", {
        params: obj
      });
      if (res.status == 200) {
        this.$router.push({
          name: "Vehicle",
          params: {
            id: type,
            isAllNewVersion: res.data
          }
        });
      } else {
        this.$message.warning(res.msg);
      }
    },
    // 点击跳转车辆详情
    getVehicleDetail(rowData) {
      if (!rowData.vin) {
        this.$message.warning("车架号为空，无法查看车辆详情");
      } else {
        this.$router.push({
          name: "VehicleInfo",
          params: {
            vin: rowData.vin,
            active: "real",
            // 点击跳转车辆详情时，通过params将该车辆定位存到url中
            detailPosition: rowData.lnglat
          }
        });
        this.$store.commit("savePosition", rowData.lnglat);
        this.$store.state.MenuStore.menu_path = "车辆管理 > 车辆管理";
      }
    },
    handleClickTableRow(row) {
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    //页数改变时触发
    handleCurrentChange(val) {
      this.currentPage = val;
      this.queryOrderList();
    },
    queryCharts() {
      this.handleClick();
    },
    // 点击派单量，发电量图表（echarts）弹窗
    handleClick() {
      let time = this.chartVal;
      if (this.stationId) {
        //查看的是站址
        if (this.activeName == "first") {
          this.getBankOrder("bigChartsOne", this.stationId, time);
        } else if (this.activeName == "second") {
          this.getBankPower("bigChartsTwo", this.stationId, time);
        } else {
          this.timeDay = null;
          this.queryOrderList(time);
        }
      } else {
        //查看的是区域
        if (this.activeName == "first") {
          this.getAreaOrderCharts("bigChartsOne", time);
        } else if (this.activeName == "second") {
          this.getAreaPowerCharts("bigChartsTwo", time);
        } else {
          this.timeDay = null;
          this.queryOrderList(time);
        }
      }
    },
    // 查询工单记录
    async queryOrderList(time = "") {
      let _this = this;
      let stationId = this.stationId ? this.stationId : "";
      if (!this.timeDay) {
        time = this.chartVal ? this.chartVal : time;
      }
      let { data: res } = await _this.$axios.get(
        "/api/v3/maintain/monitor/order/list?stationId=" +
          stationId +
          "&time=" +
          time +
          "&timeDay=" +
          this.timeDay +
          "&page=" +
          this.currentPage +
          "&limit=" +
          this.limit
      );
      if (res.code == 1) {
        _this.tableData = res.data.list;
        _this.total = res.data.totalCount;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    changeStart(val) {
      this.orderFormStartTime = val;
    },
    changeEnd(val) {
      this.orderFormEndTime = val;
    },
    changeType() {
      this.flag = this.orderForm.type == 1 ? true : false;
    },
    dispatchOrder() {
      this.addOrderVisible = true;
      this.flag = false;
      this.$resetForm(this, "orderForm");
    },
    async saveOrUpdate() {
      let _this = this;
      let startTime = "";
      let endTime = "";
      _this.$refs.orderForm.validate(async valid => {
        if (valid) {
          if (this.flag) {
            startTime = _this.orderFormStartTime;
            endTime = _this.orderFormEndTime;
            if (!startTime || !endTime) {
              this.$message.warning("请选择计划发电时间");
              return;
            }
          }
          // let orderManageAdds = []
          let parm = {
            endTime: endTime,
            startTime: startTime,
            stationId: _this.bankInfowindowData.stationId,
            type: _this.orderForm.type
          };
          let { data: res } = await _this.$axios.post(
            "/api/v3/maintain/monitor/order",
            parm
          );
          if (res.code == 1) {
            _this.addOrderVisible = false;
            _this.orderFormStartTime = "";
            _this.orderFormEndTime = "";
            _this.$resetForm(_this, "orderForm");
            _this.$message.success("操作成功");
            _this.orderTitle = "已派单";
            _this.orderDisabled = true;
            _this.queryOrder(_this.bankInfowindowData.stationId);
          } else {
            _this.$message.warning(res.msg);
          }
        }
      });
    },
    // 点击切换按钮状态改变
    switchFaultChange(val) {
      let _this = this;
      if (val) {
        if (_this.isPower) _this.isPower = false;
        if (_this.errorStatus == 1) {
          _this.closeBank();
        }
        sessionStorage.setItem("type1", true);
        _this.switchList.forEach(item => {
          if (item.type == 0) return;
          //非4S店
          if (!item.switchStatus) {
            //打开状态
            this.clearMarkers(item.type, true);
            if (item.type == 100) {
              // 告警基站
              this.getBSData(1);
            } else {
              // 银行
              this.getBankData(item.type);
            }
          }
        });
      } else {
        // 不是只显示告警站时要判断哪个按钮开启显示相应的银行点
        _this.switchList.forEach(item => {
          if (item.type != 0 && item.type != 100) {
            //非4S店和故障基站(type=1：基站，type=100：故障基站)
            if (!item.switchStatus) {
              //打开状态
              _this.clearMarkers(item.type);
              if (item.type == 1) {
                //基站
                _this.getBSData(1, 3, 0);
              } else {
                // 银行
                _this.getBankData(item.type, 3, 0);
              }
            }
          }
        });
      }
      sessionStorage.setItem("isPower", _this.isPower);
      sessionStorage.setItem("justFault", _this.justFault);
    },
    switchPowerFaultChange(val) {
      if (val) {
        if (!this.justFault) this.justFault = true;
        if (this.errorStatus == 1) {
          this.closeBank();
        }
        // 关闭只显示告警站按钮
        this.switchList.forEach(item => {
          if (item.type == 0) return;
          //非4S店
          if (!item.switchStatus) {
            //打开状态
            this.clearMarkers(item.type);
            if (item.type == 1) {
              //基站
              this.getBSData(1, 1, 1);
            } else if (item.type == 100) {
              // 告警基站
              this.getBSData(1, 2, 1);
            } else {
              // 银行
              this.getBankData(item.type, 3, 1);
            }
          }
        });
      } else {
        // 显示全部打开开关的站址标记点
        this.switchList.forEach(item => {
          if (item.type == 0) return;
          //非4S店
          if (!item.switchStatus) {
            //打开状态
            this.clearMarkers(item.type);
            if (item.type == 1) {
              //基站
              this.getBSData(1, 1);
            } else if (item.type == 100) {
              // 告警基站
              this.getBSData(1);
            } else {
              // 银行
              this.getBankData(item.type, 3);
            }
          }
        });
      }
      sessionStorage.setItem("isPower", this.isPower);
      sessionStorage.setItem("justFault", !this.justFault);
    },
    // 按钮切换清除地图海量点标记
    switchChange(item) {
      let sessionName = "type" + item.type;
      sessionStorage.setItem(sessionName, !item.switchStatus);
      if (item.switchStatus) {
        if (item.type == 0) {
          //4S
          this.getFourShopData();
        } else if (item.type == 1) {
          //正常基站
          if (this.isPower) {
            this.getBSData(1, 1, 1);
          } else {
            this.getBSData(1, 1);
          }
        } else if (item.type == 100) {
          //故障基站
          if (this.isPower) {
            this.getBSData(1, 2, 1);
          } else {
            this.getBSData(1);
          }
        } else {
          //银行
          if (this.isPower) {
            this.getBankData(item.type, 3, 1);
          } else {
            if (this.justFault) {
              // 全部显示
              this.getBankData(item.type, 3);
            } else {
              // 只显示告警站
              this.getBankData(item.type);
            }
          }
        }
      } else {
        if (item.type == this.bankType) {
          //关掉了当前选择的基站
          this.closeBank();
        } else if (this.bankType == 1 && item.type == 100) {
          this.closeBank();
        }
        if (item.type == 0) {
          //4S
          if (this.fourShopShow) {
            this.closeBank();
          }
          this.fourShopMarks.clear();
        } else if (item.type == 1) {
          //基站
          this.BSMarks.clear();
        } else if (item.type == 100) {
          this.errorBSMarks.clear();
        } else {
          //银行
          this.clearMarkers(item.type);
        }
      }
    },
    // 清除标记点
    clearMarkers(type, status) {
      switch (type) {
        case 1:
          this.BSMarks && this.BSMarks.clear();
          status && (this.switchList[0].switchStatus = true);
          break;
        // 告警基站
        case 100:
          this.errorBSMarks && this.errorBSMarks.clear();
          break;
        case 2:
          this.ABOCMarks && this.ABOCMarks.clear();
          this.errorABOCMarks && this.errorABOCMarks.clear();
          break;
        case 3:
          this.ICBCMarks && this.ICBCMarks.clear();
          this.errorICBCMarks && this.errorICBCMarks.clear();
          break;
        case 4:
          this.BOCMarks && this.BOCMarks.clear();
          this.errorBOCMarks && this.errorBOCMarks.clear();
          break;
        case 5:
          this.CCBMarks && this.CCBMarks.clear();
          this.errorCCBMarks && this.errorCCBMarks.clear();
          break;
        case 6:
          this.BCMarks && this.BCMarks.clear();
          this.errorBCMarks && this.errorBCMarks.clear();
          break;
        case 7:
          this.ZSHMarks && this.ZSHMarks.clear();
          this.errorZSHMarks && this.errorZSHMarks.clear();
          break;
        case 8:
          this.CNPCMarks && this.CNPCMarks.clear();
          this.errorCNPCMarks && this.errorCNPCMarks.clear();
          break;
        case 9:
          this.CZBMarks && this.CZBMarks.clear();
          this.errorCZBMarks && this.errorCZBMarks.clear();
          break;
        case 10:
          this.HXMarks && this.HXMarks.clear();
          this.errorHXMarks && this.errorHXMarks.clear();
          break;
        case 11:
          this.YZMarks && this.YZMarks.clear();
          this.errorYZMarks && this.errorYZMarks.clear();
          break;
        case 12:
          this.ZXMarks && this.ZXMarks.clear();
          this.errorZXMarks && this.errorZXMarks.clear();
          break;
        case 13:
          this.AGMarks && this.AGMarks.clear();
          this.errorAGMarks && this.errorAGMarks.clear();
          break;
        case 14:
          this.UNIMarks && this.UNIMarks.clear();
          this.errorUNIMarks && this.errorUNIMarks.clear();
          break;
        case 15:
          this.MOBMarks && this.MOBMarks.clear();
          this.errorMOBMarks && this.errorMOBMarks.clear();
          break;
        case 16:
          this.MSMarks && this.MSMarks.clear();
          this.errorMSMarks && this.errorMSMarks.clear();
          break;
        case 17:
          this.CMBMarks && this.CMBMarks.clear();
          this.errorCMBMarks && this.errorCMBMarks.clear();
          break;
      }
    },
    switchChangeVersion(item) {
      if (item.id == 1) {
        // 1.0 车辆状态改变
        this.vehicleVersionStatus = item.vehicleVersion;
      }
      if (item.id == 2) {
        this.vehicleVersionStatus2 = item.vehicleVersion;
      }
    },
    // 获取监控概况数据
    async refreshMonitorData() {
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/v3/maintain/monitor/general"
      );
      if (res.code == 1) {
        _this.monitorData = res.data;
        _this.vehicleTotalNum =
          res.data.vehicle.onLineCount +
          res.data.vehicle.offLineCount +
          res.data.vehicle.powerCount;
        _this.initCharts(
          "onlineCharts",
          "#1074F6",
          _this.monitorData.vehicle.onLineCount
        );
        _this.initCharts(
          "offlineCharts",
          "#A380DD",
          _this.monitorData.vehicle.offLineCount
        );
        _this.initCharts(
          "powerCharts",
          "#03C1D6",
          _this.monitorData.vehicle.powerCount
        );
      } else {
        _this.$message.warning(res.msg);
      }
    },
    // 获取区域月派单量折线图数据
    async getAreaOrderCharts(id, time = "") {
      let _this = this;
      _this.areaOrderDatax = [];
      _this.areaOrderDatay = [];
      let { data: res } = await _this.$axios.get(
        "/api/v3/maintain/monitor/kChart/order/area?time=" + time
      );
      if (res.code == 1) {
        if (
          _this.areaOrderDatax.length == 0 &&
          _this.areaOrderDatay.length == 0
        ) {
          res.data.map(item => {
            _this.areaOrderDatax.push(item.date);
            _this.areaOrderDatay.push(item.value);
          });
        }
        _this.initAreaOrderCharts(
          id,
          _this.areaOrderDatax,
          _this.areaOrderDatay
        );
      } else {
        _this.$message.warning(res.msg);
      }
    },
    // 获取区域月发电量柱状图数据
    async getAreaPowerCharts(id, time = "") {
      let _this = this;
      _this.areaPowerDatax = [];
      _this.areaPowerDatay = [];
      _this.areaPowerDatayT = [];
      let { data: res } = await _this.$axios.get(
        "/api/v3/maintain/monitor/kChart/dynamo/area?time=" + time
      );
      if (res.code == 1) {
        if (
          _this.areaPowerDatax.length == 0 &&
          _this.areaPowerDatay.length == 0 &&
          _this.areaPowerDatayT.length == 0
        ) {
          res.data.map(item => {
            _this.areaPowerDatax.push(item.date);
            _this.areaPowerDatay.push(item.value);
            _this.areaPowerDatayT.push(item.noValue);
          });
        }
        _this.initAreaPowerCharts(
          id,
          _this.areaPowerDatax,
          _this.areaPowerDatay,
          _this.areaPowerDatayT
        );
      } else {
        _this.$message.warning(res.msg);
      }
    },
    // 获取区域发电量占比
    async getPowerScaleCharts() {
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/v3/maintain/monitor/kChart/area/proportion"
      );
      if (res.code == 1) {
        _this.timeListx = [];
        _this.timeListy = [];
        _this.dynamoList = res.data.dynamoList;
        _this.year = res.data.year + "年";
        if (_this.timeListx.length == 0 && _this.timeListy.length == 0) {
          res.data.timeList.map(item => {
            _this.timeListx.push(item.name + "-" + item.topAreaName);
            _this.timeListy.push(item.value);
          });
        }
        _this.createColorCode();
        _this.initPowerScaleCharts(_this.dynamoList);
        _this.initPowerTopCharts(_this.timeListx, _this.timeListy);
      } else {
        _this.$message.warning(res.msg);
      }
    },
    // 获取4S店数据
    async getFourShopData() {
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/statistics/data/repair/shop"
      );
      if (res.code == 1) {
        _this.fourShopData = res.data;
        _this.fourShopData.filter(item => {
          return item.style == 1;
        });
        _this.addFourShopMarks();
      } else {
        _this.$message.warning(res.msg);
      }
    },
    // 添加4s店图标
    addFourShopMarks() {
      let _this = this;
      let styleObjectArr = [
        {
          url: require("@/assets/images/4S-shop.png"),
          anchor: new AMap.Pixel(6, 30),
          size: new AMap.Size(20, 30)
        },
        {
          url: require("@/assets/images/4S-shop-r.png"),
          anchor: new AMap.Pixel(6, 30),
          size: new AMap.Size(20, 30)
        },
        {
          url: require("@/assets/images/4S-shop-b.png"),
          anchor: new AMap.Pixel(6, 30),
          size: new AMap.Size(20, 30)
        }
      ];
      _this.fourShopMarks = new AMap.MassMarks(_this.fourShopData, {
        zIndex: 100, // 海量点图层叠加的顺序
        zooms: [3, 20], // 在指定地图缩放级别范围内展示海量点图层
        cursor: "pointer",
        style: styleObjectArr
      });
      _this.fourShopMarks.setMap(_this.map);
      let fourShopStatus = sessionStorage.getItem("type0");
      if (fourShopStatus == "false") {
        _this.switchList[2].switchStatus = false;
        _this.fourShopMarks.show();
      } else {
        _this.switchList[2].switchStatus = true;
        _this.fourShopMarks.hide();
      }
      AMap.event.addListener(_this.fourShopMarks, "click", function(e) {
        let lnglat = e.data.lnglat;
        _this.checkedBank.setOffset(new AMap.Pixel(-11, -5));
        _this.checkedBank.setPosition(lnglat);
        _this.map.add(_this.checkedBank);
        _this.getFourShopDetail(e.data.id);
      });
    },
    // 获取4S店信息
    async getFourShopDetail(id) {
      let _this = this;
      if (this.routeLine) {
        this.driving.clear();
        this.map.remove(this.routeLine);
        this.routeLine = null;
      }
      sessionStorage.removeItem("bankLnglat");
      this.orderShow = false;
      let { data: res } = await _this.$axios.get(
        `/api/v3/maintain/monitor/repairshop/${id}`
      );
      if (res.code == 1) {
        _this.fourShopDetail = res.data;
        _this.bankShow = true;
        _this.waterFlag = false;
        _this.fourShopShow = true;
        _this.baseStationShow = false;
        _this.bankDetailShow = false;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    // 获取站址数据，基站getBSDataitem.type
    async getBSData(type = "1", status = 2, isPower = 0) {
      let _this = this;
      if (status == 1) {
        this.loading = true;
        this.BSMarkers = [];
      } else {
        this.errorBSMarkers = [];
      }
      let { data: res } = await _this.$axios.get(
        "/api/v3/maintain/monitor/station?status=" +
          status +
          "&type=" +
          type +
          "&isPower=" +
          isPower
      );
      if (res.code == 1) {
        _this.bsData = res.data;
        _this.bsData.forEach(item => {
          item.errorStatus == 1
            ? _this.BSMarkers.push(item)
            : _this.errorBSMarkers.push(item);
        });
        if (status == 1) {
          // 基站
          _this.addBSMarks(_this.BsUrl, "2", _this.BSMarkers);
        } else if (status == 2) {
          // 告警基站
          _this.addBSMarks(_this.faultBsUrl, "1", _this.errorBSMarkers);
        } else {
          _this.addBSMarks(_this.BsUrl, "2", _this.BSMarkers);
          _this.addBSMarks(_this.faultBsUrl, "1", _this.errorBSMarkers);
        }
      } else {
        _this.loading = false;
        _this.$message.warning(res.msg);
      }
    },
    // 获取站址数据，银行
    async getBankData(type = "", status = 2, isPower = 0) {
      let _this = this;
      switch (type) {
        case 2:
          if (status == 1) {
            this.ABOCMarkers = [];
          } else if (status == 2) {
            this.errorABOCMarkers = [];
          } else {
            this.ABOCMarkers = [];
            this.errorABOCMarkers = [];
          }
          break;
        case 3:
          if (status == 1) {
            this.ICBCMarkers = [];
          } else if (status == 2) {
            this.errorICBCMarkers = [];
          } else {
            this.ICBCMarkers = [];
            this.errorICBCMarkers = [];
          }
          break;
        case 4:
          if (status == 1) {
            this.BOCMarkers = [];
          } else if (status == 2) {
            this.errorBOCMarkers = [];
          } else {
            this.BOCMarkers = [];
            this.errorBOCMarkers = [];
          }
          break;
        case 5:
          if (status == 1) {
            this.CCBMarkers = [];
          } else if (status == 2) {
            this.errorCCBMarkers = [];
          } else {
            this.CCBMarkers = [];
            this.errorCCBMarkers = [];
          }
          break;
        case 6:
          if (status == 1) {
            this.BCMarkers = [];
          } else if (status == 2) {
            this.errorBCMarkers = [];
          } else {
            this.BCMarkers = [];
            this.errorBCMarkers = [];
          }
          break;
        case 7:
          if (status == 1) {
            this.ZSHMarkers = [];
          } else if (status == 2) {
            this.errorZSHMarkers = [];
          } else {
            this.ZSHMarkers = [];
            this.errorZSHMarkers = [];
          }
          break;
        case 8:
          if (status == 1) {
            this.CNPCMarkers = [];
          } else if (status == 2) {
            this.errorCNPCMarkers = [];
          } else {
            this.CNPCMarkers = [];
            this.errorCNPCMarkers = [];
          }
          break;
        case 9:
          if (status == 1) {
            this.CZBMarkers = [];
          } else if (status == 2) {
            this.errorCZBMarkers = [];
          } else {
            this.CZBMarkers = [];
            this.errorCZBMarkers = [];
          }
          break;
        case 10:
          if (status == 1) {
            this.HXMarkers = [];
          } else if (status == 2) {
            this.errorHXMarkers = [];
          } else {
            this.HXMarkers = [];
            this.errorHXMarkers = [];
          }
          break;
        case 11:
          if (status == 1) {
            this.YZMarkers = [];
          } else if (status == 2) {
            this.errorYZMarkers = [];
          } else {
            this.YZMarkers = [];
            this.errorYZMarkers = [];
          }
          break;
        case 12:
          if (status == 1) {
            this.ZXMarkers = [];
          } else if (status == 2) {
            this.errorZXMarkers = [];
          } else {
            this.ZXMarkers = [];
            this.errorZXMarkers = [];
          }
          break;
        case 13:
          if (status == 1) {
            this.AGMarkers = [];
          } else if (status == 2) {
            this.errorAGMarkers = [];
          } else {
            this.AGMarkers = [];
            this.errorAGMarkers = [];
          }
          break;
        case 14:
          if (status == 1) {
            this.UNIMarkers = [];
          } else if (status == 2) {
            this.errorUNIMarkers = [];
          } else {
            this.UNIMarkers = [];
            this.errorUNIMarkers = [];
          }
          break;
        case 15:
          if (status == 1) {
            this.MOBMarkers = [];
          } else if (status == 2) {
            this.errorMOBMarkers = [];
          } else {
            this.MOBMarkers = [];
            this.errorMOBMarkers = [];
          }
          break;
        case 16:
          if (status == 1) {
            this.MSMarkers = [];
          } else if (status == 2) {
            this.errorMSMarkers = [];
          } else {
            this.MSMarkers = [];
            this.errorMSMarkers = [];
          }
          break;
        case 17:
          if (status == 1) {
            this.CMBMarkers = [];
          } else if (status == 2) {
            this.errorCMBMarkers = [];
          } else {
            this.CMBMarkers = [];
            this.errorCMBMarkers = [];
          }
          break;
      }
      let { data: res } = await _this.$axios.get(
        "/api/v3/maintain/monitor/station?status=" +
          status +
          "&type=" +
          type +
          "&isPower=" +
          isPower
      );
      if (res.code == 1) {
        if (res.data) {
          _this.bankData = res.data;
          if (_this.bankData.length > 0) {
            _this.bankData.forEach(item => {
              switch (item.type) {
                case 2:
                  item.errorStatus == 1
                    ? _this.ABOCMarkers.push(item)
                    : _this.errorABOCMarkers.push(item);
                  break;
                case 3:
                  item.errorStatus == 1
                    ? _this.ICBCMarkers.push(item)
                    : _this.errorICBCMarkers.push(item);
                  break;
                case 4:
                  item.errorStatus == 1
                    ? _this.BOCMarkers.push(item)
                    : _this.errorBOCMarkers.push(item);
                  break;
                case 5:
                  item.errorStatus == 1
                    ? _this.CCBMarkers.push(item)
                    : _this.errorCCBMarkers.push(item);
                  break;
                case 6:
                  item.errorStatus == 1
                    ? _this.BCMarkers.push(item)
                    : _this.errorBCMarkers.push(item);
                  break;
                case 7:
                  item.errorStatus == 1
                    ? _this.ZSHMarkers.push(item)
                    : _this.errorZSHMarkers.push(item);
                  break;
                case 8:
                  item.errorStatus == 1
                    ? _this.CNPCMarkers.push(item)
                    : _this.errorCNPCMarkers.push(item);
                  break;
                case 9:
                  item.errorStatus == 1
                    ? _this.CZBMarkers.push(item)
                    : _this.errorCZBMarkers.push(item);
                  break;
                case 10:
                  item.errorStatus == 1
                    ? _this.HXMarkers.push(item)
                    : _this.errorHXMarkers.push(item);
                  break;
                case 11:
                  item.errorStatus == 1
                    ? _this.YZMarkers.push(item)
                    : _this.errorYZMarkers.push(item);
                  break;
                case 12:
                  item.errorStatus == 1
                    ? _this.ZXMarkers.push(item)
                    : _this.errorZXMarkers.push(item);
                  break;
                case 13:
                  item.errorStatus == 1
                    ? _this.AGMarkers.push(item)
                    : _this.errorAGMarkers.push(item);
                  break;
                case 14:
                  item.errorStatus == 1
                    ? _this.UNIMarkers.push(item)
                    : _this.errorUNIMarkers.push(item);
                  break;
                case 15:
                  item.errorStatus == 1
                    ? _this.MOBMarkers.push(item)
                    : _this.errorMOBMarkers.push(item);
                  break;
                case 16:
                  item.errorStatus == 1
                    ? _this.MSMarkers.push(item)
                    : _this.errorMSMarkers.push(item);
                  break;
                case 17:
                  item.errorStatus == 1
                    ? _this.CMBMarkers.push(item)
                    : _this.errorCMBMarkers.push(item);
                  break;
              }
            });
          }
          const bankConfig = {
            2: {
              prefix: "ABOC",
              normalUrl: _this.ABOCUrl,
              faultUrl: _this.faultABOCUrl,
              normalNum: "4",
              faultNum: "3"
            },
            3: {
              prefix: "ICBC",
              normalUrl: _this.ICBCUrl,
              faultUrl: _this.faultICBCUrl,
              normalNum: "6",
              faultNum: "5"
            },
            4: {
              prefix: "BOC",
              normalUrl: _this.BOCUrl,
              faultUrl: _this.faultBOCUrl,
              normalNum: "8",
              faultNum: "7"
            },
            5: {
              prefix: "CCB",
              normalUrl: _this.CCBUrl,
              faultUrl: _this.faultCCBUrl,
              normalNum: "10",
              faultNum: "9"
            },
            6: {
              prefix: "BC",
              normalUrl: _this.BCUrl,
              faultUrl: _this.faultBCUrl,
              normalNum: "12",
              faultNum: "11"
            },
            7: {
              prefix: "ZSH",
              normalUrl: _this.ZSHUrl,
              faultUrl: _this.faultZSHUrl,
              normalNum: "14",
              faultNum: "13"
            },
            8: {
              prefix: "CNPC",
              normalUrl: _this.CNPUrl,
              faultUrl: _this.faultCNPUrl,
              normalNum: "16",
              faultNum: "15"
            },
            9: {
              prefix: "CZB",
              normalUrl: _this.CZBUrl,
              faultUrl: _this.faultCZBUrl,
              normalNum: "18",
              faultNum: "17"
            },
            10: {
              prefix: "HX",
              normalUrl: _this.HXUrl,
              faultUrl: _this.faultHXUrl,
              normalNum: "20",
              faultNum: "19"
            },
            11: {
              prefix: "YZ",
              normalUrl: _this.YZUrl,
              faultUrl: _this.faultYZUrl,
              normalNum: "22",
              faultNum: "21"
            },
            12: {
              prefix: "ZX",
              normalUrl: _this.ZXUrl,
              faultUrl: _this.faultZXUrl,
              normalNum: "24",
              faultNum: "23"
            },
            13: {
              prefix: "AG",
              normalUrl: _this.AGUrl,
              faultUrl: _this.faultAGUrl,
              normalNum: "26",
              faultNum: "25"
            },
            14: {
              prefix: "UNI",
              normalUrl: _this.UNIUrl,
              faultUrl: _this.faultUNIUrl,
              normalNum: "28",
              faultNum: "27"
            },
            15: {
              prefix: "MOB",
              normalUrl: _this.MOBUrl,
              faultUrl: _this.faultMOBUrl,
              normalNum: "30",
              faultNum: "29"
            },
            16: {
              prefix: "MS",
              normalUrl: _this.MSUrl,
              faultUrl: _this.faultMSUrl,
              normalNum: "32",
              faultNum: "31"
            },
            17: {
              prefix: "CMB",
              normalUrl: _this.CMBUrl,
              faultUrl: _this.faultCMBUrl,
              normalNum: "34",
              faultNum: "33"
            }
          };
          if (bankConfig[type]) {
            const config = bankConfig[type];
            const typeStr = type.toString();
            if (status == 1) {
              _this.addBankMarks(
                config.normalUrl,
                config.normalNum,
                _this[`${config.prefix}Markers`],
                typeStr
              );
            } else if (status == 2) {
              _this.addBankMarks(
                config.faultUrl,
                config.faultNum,
                _this[`error${config.prefix}Markers`],
                typeStr
              );
            } else {
              _this.addBankMarks(
                config.normalUrl,
                config.normalNum,
                _this[`${config.prefix}Markers`],
                typeStr
              );
              _this.addBankMarks(
                config.faultUrl,
                config.faultNum,
                _this[`error${config.prefix}Markers`],
                typeStr
              );
            }
          }
        }
      } else {
        _this.$message.warning(res.msg);
      }
    },
    // 添加基站标注
    addBSMarks(img, singel, all) {
      let _this = this;
      let style = {
        url: img,
        anchor: new AMap.Pixel(6, 30),
        size: new AMap.Size(20, 28)
      };
      switch (singel) {
        case "1":
          singel = _this.errorBSMarks = new AMap.MassMarks(all, {
            zIndex: 100, // 海量点图层叠加的顺序
            zooms: [3, 20], // 在指定地图缩放级别范围内展示海量点图层
            cursor: "pointer",
            style: style
          });
          singel.setMap(this.map);
          break;
        case "2":
          singel = _this.BSMarks = new AMap.MassMarks(all, {
            zIndex: 100, // 海量点图层叠加的顺序
            zooms: [3, 20], // 在指定地图缩放级别范围内展示海量点图层
            cursor: "pointer",
            style: style
          });
          singel.setMap(this.map);
          _this.loading = false;
          break;
      }
      AMap.event.addListener(singel, "click", function(e) {
        _this.errorStatus = e.data.errorStatus;
        _this.bankType = e.data.type;
        _this.stationVehicleId = null;
        _this.vin = null;
        let stationId = e.data.stationId;
        let lnglat = e.data.lnglat;
        _this.checkedBank.setOffset(new AMap.Pixel(-11, -7));
        _this.checkedBank.setPosition(lnglat);
        _this.map.add(_this.checkedBank);
        _this.getBankDetail(stationId, "baseStation");
        _this.getReceip(stationId, lnglat);
      });
    },
    // 添加银行标注
    addBankMarks(img, singel, all) {
      let _this = this;
      let style = {
        url: img,
        anchor: new AMap.Pixel(10, 30),
        size: new AMap.Size(24, 28)
      };
      switch (singel) {
        case "3":
          singel = _this.errorABOCMarks = new AMap.MassMarks(all, {
            zIndex: 100, // 海量点图层叠加的顺序
            zooms: [3, 20], // 在指定地图缩放级别范围内展示海量点图层
            cursor: "pointer",
            style: style
          });
          singel.setMap(this.map);
          break;
        case "4":
          singel = _this.ABOCMarks = new AMap.MassMarks(all, {
            zIndex: 100, // 海量点图层叠加的顺序
            zooms: [3, 20], // 在指定地图缩放级别范围内展示海量点图层
            cursor: "pointer",
            style: style
          });
          singel.setMap(this.map);
          break;
        case "5":
          singel = _this.errorICBCMarks = new AMap.MassMarks(all, {
            zIndex: 100, // 海量点图层叠加的顺序
            zooms: [3, 20], // 在指定地图缩放级别范围内展示海量点图层
            cursor: "pointer",
            style: style
          });
          singel.setMap(this.map);
          break;
        case "6":
          singel = _this.ICBCMarks = new AMap.MassMarks(all, {
            zIndex: 100, // 海量点图层叠加的顺序
            zooms: [3, 20], // 在指定地图缩放级别范围内展示海量点图层
            cursor: "pointer",
            style: style
          });
          singel.setMap(this.map);
          break;
        case "7":
          singel = _this.errorBOCMarks = new AMap.MassMarks(all, {
            zIndex: 100, // 海量点图层叠加的顺序
            zooms: [3, 20], // 在指定地图缩放级别范围内展示海量点图层
            cursor: "pointer",
            style: style
          });
          singel.setMap(this.map);
          break;
        case "8":
          singel = _this.BOCMarks = new AMap.MassMarks(all, {
            zIndex: 100, // 海量点图层叠加的顺序
            zooms: [3, 20], // 在指定地图缩放级别范围内展示海量点图层
            cursor: "pointer",
            style: style
          });
          singel.setMap(this.map);
          break;
        case "9":
          singel = _this.errorCCBMarks = new AMap.MassMarks(all, {
            zIndex: 100, // 海量点图层叠加的顺序
            zooms: [3, 20], // 在指定地图缩放级别范围内展示海量点图层
            cursor: "pointer",
            style: style
          });
          singel.setMap(this.map);
          break;
        case "10":
          singel = _this.CCBMarks = new AMap.MassMarks(all, {
            zIndex: 100, // 海量点图层叠加的顺序
            zooms: [3, 20], // 在指定地图缩放级别范围内展示海量点图层
            cursor: "pointer",
            style: style
          });
          singel.setMap(this.map);
          break;
        case "11":
          singel = _this.errorBCMarks = new AMap.MassMarks(all, {
            zIndex: 100, // 海量点图层叠加的顺序
            zooms: [3, 20], // 在指定地图缩放级别范围内展示海量点图层
            cursor: "pointer",
            style: style
          });
          singel.setMap(this.map);
          break;
        case "12":
          singel = _this.BCMarks = new AMap.MassMarks(all, {
            zIndex: 100, // 海量点图层叠加的顺序
            zooms: [3, 20], // 在指定地图缩放级别范围内展示海量点图层
            cursor: "pointer",
            style: style
          });
          singel.setMap(this.map);
          break;
        case "13":
          singel = _this.errorZSHMarks = new AMap.MassMarks(all, {
            zIndex: 100, // 海量点图层叠加的顺序
            zooms: [3, 20], // 在指定地图缩放级别范围内展示海量点图层
            cursor: "pointer",
            style: style
          });
          singel.setMap(this.map);
          break;
        case "14":
          singel = _this.ZSHMarks = new AMap.MassMarks(all, {
            zIndex: 100, // 海量点图层叠加的顺序
            zooms: [3, 20], // 在指定地图缩放级别范围内展示海量点图层
            cursor: "pointer",
            style: style
          });
          singel.setMap(this.map);
          break;
        case "15":
          singel = _this.errorCNPCMarks = new AMap.MassMarks(all, {
            zIndex: 100, // 海量点图层叠加的顺序
            zooms: [3, 20], // 在指定地图缩放级别范围内展示海量点图层
            cursor: "pointer",
            style: style
          });
          singel.setMap(this.map);
          break;
        case "16":
          singel = _this.CNPCMarks = new AMap.MassMarks(all, {
            zIndex: 100, // 海量点图层叠加的顺序
            zooms: [3, 20], // 在指定地图缩放级别范围内展示海量点图层
            cursor: "pointer",
            style: style
          });
          singel.setMap(this.map);
          break;
        case "17":
          singel = _this.errorCZBMarks = new AMap.MassMarks(all, {
            zIndex: 100, // 海量点图层叠加的顺序
            zooms: [3, 20], // 在指定地图缩放级别范围内展示海量点图层
            cursor: "pointer",
            style: style
          });
          singel.setMap(this.map);
          break;
        case "18":
          singel = _this.CZBMarks = new AMap.MassMarks(all, {
            zIndex: 100, // 海量点图层叠加的顺序
            zooms: [3, 20], // 在指定地图缩放级别范围内展示海量点图层
            cursor: "pointer",
            style: style
          });
          singel.setMap(this.map);
          break;
        case "19":
          singel = _this.errorHXMarks = new AMap.MassMarks(all, {
            zIndex: 100, // 海量点图层叠加的顺序
            zooms: [3, 20], // 在指定地图缩放级别范围内展示海量点图层
            cursor: "pointer",
            style: style
          });
          singel.setMap(this.map);
          break;
        case "20":
          singel = _this.HXMarks = new AMap.MassMarks(all, {
            zIndex: 100, // 海量点图层叠加的顺序
            zooms: [3, 20], // 在指定地图缩放级别范围内展示海量点图层
            cursor: "pointer",
            style: style
          });
          singel.setMap(this.map);
          break;
        case "21":
          singel = _this.errorYZMarks = new AMap.MassMarks(all, {
            zIndex: 100, // 海量点图层叠加的顺序
            zooms: [3, 20], // 在指定地图缩放级别范围内展示海量点图层
            cursor: "pointer",
            style: style
          });
          singel.setMap(this.map);
          break;
        case "22":
          singel = _this.YZMarks = new AMap.MassMarks(all, {
            zIndex: 100, // 海量点图层叠加的顺序
            zooms: [3, 20], // 在指定地图缩放级别范围内展示海量点图层
            cursor: "pointer",
            style: style
          });
          singel.setMap(this.map);
          break;
        case "23":
          singel = _this.errorZXMarks = new AMap.MassMarks(all, {
            zIndex: 100, // 海量点图层叠加的顺序
            zooms: [3, 20], // 在指定地图缩放级别范围内展示海量点图层
            cursor: "pointer",
            style: style
          });
          singel.setMap(this.map);
          break;
        case "24":
          singel = _this.ZXMarks = new AMap.MassMarks(all, {
            zIndex: 100, // 海量点图层叠加的顺序
            zooms: [3, 20], // 在指定地图缩放级别范围内展示海量点图层
            cursor: "pointer",
            style: style
          });
          singel.setMap(this.map);
          break;
        case "25":
          singel = _this.errorAGMarks = new AMap.MassMarks(all, {
            zIndex: 100, // 海量点图层叠加的顺序
            zooms: [3, 20], // 在指定地图缩放级别范围内展示海量点图层
            cursor: "pointer",
            style: style
          });
          singel.setMap(this.map);
          break;
        case "26":
          singel = _this.AGMarks = new AMap.MassMarks(all, {
            zIndex: 100, // 海量点图层叠加的顺序
            zooms: [3, 20], // 在指定地图缩放级别范围内展示海量点图层
            cursor: "pointer",
            style: style
          });
          singel.setMap(this.map);
          break;
        case "27":
          singel = _this.errorUNIMarks = new AMap.MassMarks(all, {
            zIndex: 100, // 海量点图层叠加的顺序
            zooms: [3, 20], // 在指定地图缩放级别范围内展示海量点图层
            cursor: "pointer",
            style: style
          });
          singel.setMap(this.map);
          break;
        case "28":
          singel = _this.UNIMarks = new AMap.MassMarks(all, {
            zIndex: 100, // 海量点图层叠加的顺序
            zooms: [3, 20], // 在指定地图缩放级别范围内展示海量点图层
            cursor: "pointer",
            style: style
          });
          singel.setMap(this.map);
          break;
        case "29":
          singel = _this.errorMOBMarks = new AMap.MassMarks(all, {
            zIndex: 100, // 海量点图层叠加的顺序
            zooms: [3, 20], // 在指定地图缩放级别范围内展示海量点图层
            cursor: "pointer",
            style: style
          });
          singel.setMap(this.map);
          break;
        case "30":
          singel = _this.MOBMarks = new AMap.MassMarks(all, {
            zIndex: 100, // 海量点图层叠加的顺序
            zooms: [3, 20], // 在指定地图缩放级别范围内展示海量点图层
            cursor: "pointer",
            style: style
          });
          singel.setMap(this.map);
          break;
        case "31":
          singel = _this.errorMSMarks = new AMap.MassMarks(all, {
            zIndex: 100, // 海量点图层叠加的顺序
            zooms: [3, 20], // 在指定地图缩放级别范围内展示海量点图层
            cursor: "pointer",
            style: style
          });
          singel.setMap(this.map);
          break;
        case "32":
          singel = _this.MSMarks = new AMap.MassMarks(all, {
            zIndex: 100, // 海量点图层叠加的顺序
            zooms: [3, 20], // 在指定地图缩放级别范围内展示海量点图层
            cursor: "pointer",
            style: style
          });
          singel.setMap(this.map);
          break;
        case "33":
          singel = _this.errorCMBMarks = new AMap.MassMarks(all, {
            zIndex: 100, // 海量点图层叠加的顺序
            zooms: [3, 20], // 在指定地图缩放级别范围内展示海量点图层
            cursor: "pointer",
            style: style
          });
          singel.setMap(this.map);
          break;
        case "34":
          singel = _this.CMBMarks = new AMap.MassMarks(all, {
            zIndex: 100, // 海量点图层叠加的顺序
            zooms: [3, 20], // 在指定地图缩放级别范围内展示海量点图层
            cursor: "pointer",
            style: style
          });
          singel.setMap(this.map);
          break;
      }
      AMap.event.addListener(singel, "click", e => {
        _this.errorStatus = e.data.errorStatus;
        _this.stationVehicleId = null;
        _this.vin = null;
        _this.bankType = e.data.type; //当前选择的站址类别
        let stationId = e.data.stationId;
        let lnglat = e.data.lnglat;
        _this.checkedBank.setOffset(new AMap.Pixel(-13, -7));
        _this.checkedBank.setPosition(lnglat);
        _this.map.add(_this.checkedBank);
        _this.getBankDetail(stationId, "bank");
        _this.getReceip(stationId, lnglat);
      });
    },
    //获取站址详细信息
    async getBankDetail(stationId, name) {
      let _this = this;
      if (this.routeLine) {
        this.driving.clear();
        this.map.remove(this.routeLine);
        this.routeLine = null;
      }
      this.orderShow = false;
      let { data: res } = await _this.$axios.get(
        `/api/v3/maintain/monitor/station/${stationId}`
      );
      if (res.code == 1) {
        _this.bankInfowindowData = res.data;
        _this.drivingRoutelVin = null;
        _this.stationId = _this.bankInfowindowData.stationId;
        _this.bankShow = true;
        _this.waterFlag = false;
        _this.fourShopShow = false;
        if (name == "bank") {
          _this.baseStationShow = false;
          _this.bankDetailShow = true;
        } else {
          _this.baseStationShow = true;
          _this.bankDetailShow = false;
        }
        if (_this.bankInfowindowData.orderStatus == 3) {
          //站址派单且已接单
          if (res.data.vehicleLnglat && res.data.vehicleLnglat.length) {
            //说明有车辆接单
            _this.drivingRoutelVin = _this.bankInfowindowData.vin;
            _this.drawRouteLine(
              res.data.vehicleLnglat,
              res.data.stationLnglat,
              "#00E46B"
            );
          }
        } else {
          sessionStorage.setItem("bankLnglat", res.data.stationLnglat);
        }
        if (res.data.orderStatus == 1) {
          _this.orderTitle = "派单";
          _this.orderDisabled = false;
        } else {
          _this.orderTitle = "已派单";
          _this.orderDisabled = true;
          _this.queryOrder(stationId);
        }
        _this.$nextTick(() => {
          _this.getBankOrder("bankOrderCharts", stationId);
          _this.getBankPower("bankPowerCharts", stationId);
        });
      } else {
        _this.$message.warning(res.msg);
      }
    },
    // 获取站址未回单车辆
    async getReceip(stationId, lnglat) {
      let _this = this;
      let { data: res } = await _this.$axios.get(
        `/api/v3/maintain/monitor/station/receip/${stationId}`
      );
      if (res.code == 1) {
        _this.receipVehicle = res.data;
        if (_this.receipVehicle && _this.receipVehicle.length > 0) {
          _this.baseStationId = true;
          _this.baseStationInfoWindow.open(_this.map, lnglat);
        } else {
          _this.baseStationId = false;
        }
      } else {
        _this.$message.warning(res.msg);
      }
    },
    // 查询工单进度
    async queryOrder(stationId) {
      let _this = this;
      this.time = null;
      clearInterval(this.orderTimer);
      let { data: res } = await _this.$axios.get(
        `/api/v3/maintain/monitor/order/schedule/${stationId}`
      );
      if (res.code == 1) {
        if (res.data.close == 1) {
          // 计算等待时间
          _this.queryTime(res.data.startTime);
          _this.orderTimer = setInterval(() => {
            _this.queryTime(res.data.startTime);
          }, 1000);
          _this.orderDesc = res.data;
          _this.orderShow = true;
        }
      } else {
        _this.$message.warning(res.msg);
      }
    },
    // 计算时间差
    queryTime(time) {
      var date = new Date().getTime() - new Date(time).getTime(); //时间差的毫秒数
      if (date > 0) {
        //派单时间早于当前时间
        //计算出小时数
        var leave1 = date % (3600 * 1000);
        var hours = Math.floor(date / (3600 * 1000)).toString();
        //计算相差分钟数
        var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
        var minutes = Math.floor(leave2 / (60 * 1000)).toString();
        //计算相差秒数
        var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
        var seconds = Math.round(leave3 / 1000).toString();
        hours = Number(hours) > 9 ? hours : "0" + hours;
        minutes = Number(minutes) > 9 ? minutes : "0" + minutes;
        seconds = Number(seconds) > 9 ? seconds : "0" + seconds;
        this.time = hours + ":" + minutes + ":" + seconds;
      } else {
        //派单时间晚于当前时间
        this.time = "00:00:00";
      }
    },
    // 根据起始点画路线
    drawRouteLine(start, end, color) {
      let _this = this;
      if (_this.routeLine || !_this.drawOK) {
        _this.driving.clear();
        _this.map.remove(_this.routeLine);
        _this.routeLine = null;
        _this.drivingRoutelVin = null;
        _this.drawOK = true;
      }
      _this.drivingRoutel = "";
      _this.drivingTime = "";
      if (start.length > 0 && _this.drawOK) {
        _this.drawOK = false;
        // 根据起终点经纬度规划驾车导航路线
        _this.driving.search(
          new AMap.LngLat(start[0], start[1]),
          new AMap.LngLat(end[0], end[1]),
          (status, result) => {
            var path = [];
            for (var i = 0, l = result.routes[0].steps.length; i < l; i++) {
              var step = result.routes[0].steps[i];
              for (var j = 0, n = step.path.length; j < n; j++) {
                path.push(step.path[j]);
              }
            }
            _this.drivingRoutel = result.routes[0].distance / 1000 + "公里";
            let hours = Math.floor(result.routes[0].time / 3600);
            let mintinus = Math.floor(result.routes[0].time / 60 - hours * 60);
            _this.drivingTime = hours + "小时" + mintinus + "分钟";
            _this.bankRoute = true;
            _this.routeLine = new AMap.Polyline({
              map: _this.map,
              path: path,
              isOutline: false,
              strokeWeight: 4,
              strokeColor: color,
              lineJoin: "round"
            });
            _this.drawOK = true;
          }
        );
      }
    },
    //获取站址月派单
    async getBankOrder(id, stationId, time = "") {
      let _this = this;
      _this.orderDatax = [];
      _this.orderDatay = [];
      let { data: res } = await _this.$axios.get(
        `/api/v3/maintain/monitor/kChart/order/station/${stationId}?time=${time}`
      );
      if (res.code == 1) {
        res.data.map(item => {
          _this.orderDatax.push(item.date);
          _this.orderDatay.push(item.value);
        });
        _this.initBankCharts(id, "#5B6CC4", _this.orderDatax, _this.orderDatay);
      } else {
        _this.$message.warning(res.msg);
      }
    },
    //获取站址月发电
    async getBankPower(id, stationId, time = "") {
      let _this = this;
      _this.powerDatax = [];
      _this.powerDatay = [];
      let { data: res } = await _this.$axios.get(
        `/api/v3/maintain/monitor/kChart/dynamo/station/${stationId}?time=${time}`
      );
      if (res.code == 1) {
        res.data.map(item => {
          _this.powerDatax.push(item.date);
          _this.powerDatay.push(item.value);
        });
        _this.initBankCharts(id, "#29C2B7", _this.powerDatax, _this.powerDatay);
      } else {
        _this.$message.warning(res.msg);
      }
    },
    //获取车辆定位信息
    async getVehicleLocation() {
      let _this = this;
      let obj = {};
      obj.vehicleType = this.vehicleType;
      let { data: res } = await _this.$axios.get(
        "/api/v3/maintain/monitor/vehicle",
        {
          params: obj
        }
      );
      if (res.code == 1) {
        _this.vehicleLocal = res.data;
        _this.addVehicleMarker();
      } else {
        _this.$message.warning(res.msg);
      }
    },
    //添加车辆标记
    addVehicleMarker() {
      let _this = this;
      let data = this.vehicleLocal;
      if (this.vehicleMarker.length > 0) {
        this.map.remove(this.vehicleMarker);
        this.vehicleMarkerList = [];
        this.vehicleMarker = [];
      }
      for (var i = 0; i < data.length; i++) {
        _this.varMarker = "";
        // _this.oilStateMarker = ""
        _this.powerStateMarker = "";
        _this.plateNumMarker = "";
        // if (data[i].oilPumpingState == 1) {
        //   var oilContent =
        //     "<img style='width:14px;height:18px'  src='" +
        //     require("@/assets/images/monitor/icon-fueling.png") +
        //     "'/>"
        //   _this.oilStateMarker = new AMap.Marker({
        //     zIndex: 200,
        //     content: oilContent,
        //     position: data[i].lnglat,
        //     offset: new AMap.Pixel(-30, 8),
        //     map: _this.map,
        //   })
        // }
        if (data[i].powerState == 1) {
          var powerContent =
            "<img style='width:14px;height:18px'  src='" +
            require("@/assets/images/monitor/icon-powering.png") +
            "'/>";
          _this.powerStateMarker = new AMap.Marker({
            zIndex: 200,
            content: powerContent,
            position: data[i].lnglat,
            offset: new AMap.Pixel(-30, -12),
            map: _this.map
          });
        }
        if (data[i].vehicleState == 1) {
          let icon =
            data[i].version == 2
              ? require("@/assets/images/monitor/car-offline-2.0.png")
              : require("@/assets/images/monitor/car-offline.png");
          _this.varMarker = new AMap.Marker({
            position: data[i].lnglat,
            icon: icon,
            size: new AMap.Size(40, 24),
            map: _this.map,
            autoRotation: true, // 车辆行驶过程中，方向可变属性
            offset: new AMap.Pixel(-20, -12),
            clickable: true,
            zIndex: 100,
            angel: -90
          });
          var plateNumContent =
            "<div style='position:relative'><img style='width:88px;height:27px'  src='" +
            require("@/assets/images/monitor/plateNum.png") +
            "'/><span style='position:absolute;color:#fff;font-size:12px;left:50%;top:40%;" +
            "transform:translate(-50%,-50%);text-wrap:nowrap;width:88px;text-align:center'>" +
            data[i].plateNum +
            "</span></div>";
          _this.plateNumMarker = new AMap.Marker({
            zIndex: 100,
            content: plateNumContent,
            position: data[i].lnglat,
            offset: new AMap.Pixel(-40, -42),
            map: _this.map
          });
        } else {
          let icon =
            data[i].version == 2
              ? require("@/assets/images/monitor/car-online-2.png")
              : require("@/assets/images/monitor/car-online.png");
          _this.varMarker = new AMap.Marker({
            position: data[i].lnglat,
            icon: icon,
            size: new AMap.Size(40, 24),
            map: _this.map,
            autoRotation: true, // 车辆行驶过程中，方向可变属性
            offset: new AMap.Pixel(-20, -12),
            zIndex: 120,
            clickable: true,
            angel: -90
          });
          var plateContent =
            "<div style='position:relative'><img style='width:88px;height:27px'  src='" +
            require("@/assets/images/monitor/plateNum.png") +
            "'/><span style='position:absolute;color:#fff;font-size:12px;left:50%;top:40%;" +
            "transform:translate(-50%,-50%);text-wrap:nowrap;width:88px;text-align:center'>" +
            data[i].plateNum +
            "</span></div>";
          _this.plateNumMarker = new AMap.Marker({
            zIndex: 120,
            content: plateContent,
            position: data[i].lnglat,
            offset: new AMap.Pixel(-40, -42),
            map: _this.map
          });
          // 判断车辆方向
          _this.varMarker.moveAlong(data[i].directionLnglat, 50); //车辆行驶方向
        }
        _this.varMarker.content = data[i]; // 车辆信息窗体内容
        _this.plateNumMarker.content = data[i]; // 车辆信息窗体内容
        _this.vehicleMarker.push(_this.varMarker);
        // _this.vehicleMarker.push(_this.oilStateMarker)
        _this.vehicleMarker.push(_this.powerStateMarker);
        _this.vehicleMarker.push(_this.plateNumMarker);
        _this.vehicleMarkerList.push({
          vin: data[i].vin,
          lnglat: data[i].lnglat,
          vehicle: _this.varMarker,
          plateNum: _this.plateNumMarker,
          // oil: _this.oilStateMarker,
          power: _this.powerStateMarker
        });
        AMap.event.addListener(_this.varMarker, "click", function(e) {
          _this.vin = e.target.content.vin;
          _this.deptId = e.target.content.deptId;
          _this.monitorLnglat = e.target.content.lnglat;
          _this.getVehicleInfowindow(_this.vin, _this.deptId);
        });
        AMap.event.addListener(_this.varMarker, "mouseover", function(e) {
          e.target.setTop(true);
        });
        AMap.event.addListener(_this.varMarker, "mouseout", function(e) {
          e.target.setTop(false);
        });
        AMap.event.addListener(_this.plateNumMarker, "click", function(e) {
          _this.vin = e.target.content.vin;
          _this.deptId = e.target.content.deptId;
          _this.getVehicleInfowindow(_this.vin, _this.deptId);
        });
        AMap.event.addListener(_this.plateNumMarker, "mouseover", function(e) {
          e.target.setTop(true);
        });
        AMap.event.addListener(_this.plateNumMarker, "mouseout", function(e) {
          e.target.setTop(false);
        });
      }
      _this.$nextTick(() => {
        _this.map.add(_this.vehicleMarker);
        // if (_this.locationError) {
        //   _this.map.setFitView();
        // }
      });
    },
    // 监听车辆标记的点击事件
    monitorVehicleMarkerEvent(vin, deptId) {
      this.getVehicleInfowindow(vin, deptId);
    },
    // 切换信息窗体显示位置
    turnDirection() {
      this.turnLeftOn = !this.turnLeftOn;
    },
    // 点击查询车辆详情
    async getVehicleInfowindow(vin, deptId) {
      let _this = this;
      if (_this.routeLine) {
        _this.driving.clear();
        _this.map.remove(_this.routeLine);
        _this.routeLine = null;
      }
      let { data: res } = await _this.$axios.get(
        "/api/v3/maintain/monitor/vehicle/details?deptId=" +
          deptId +
          "&vin=" +
          vin
      );
      if (res.code == 1) {
        _this.vehicleInfoWindowData = {};
        _this.vehicleInfoWindowData = res.data;
        sessionStorage.setItem("lnglat", res.data.lnglat);
        _this.stationVehicleId = _this.vehicleInfoWindowData.stationId;
        _this.vehicleId = true;
        // 车辆信息窗体
        _this.vehicleInfoWindow = new AMap.Marker({
          map: _this.map,
          content: this.$refs.vehicleInfowindow.$el,
          zIndex: 300,
          offset: new AMap.Pixel(30, -40)
        });
        _this.$nextTick(() => {
          _this.turnLeftOn = false;
          _this.vehicleInfoWindow.show();
          _this.vehicleInfoWindow.setPosition(res.data.lnglat);
        });
        _this.drivingRoutelVin = null;
        // let lnglat=sessionStorage.getItem("lnglat")
        // let bankLnglat = sessionStorage.getItem("bankLnglat")
        _this.bankRoute = false;
        if (res.data.destLnglat && res.data.destLnglat.length > 0) {
          // 如果车辆有目的地
          _this.drivingRoutelVin = _this.vehicleInfoWindowData.vin;
          _this.drawRouteLine(res.data.lnglat, res.data.destLnglat, "#00E46B");
        } else {
          // if (
          //   bankLnglat &&
          //   _this.vehicleInfoWindowData.powerState != 1 &&
          //   _this.vehicleInfoWindowData.orderState == 1
          // ) {
          //   bankLnglat = bankLnglat.split(",")
          //   _this.drivingRoutelVin = _this.vehicleInfoWindowData.vin
          //   _this.drawRouteLine(res.data.lnglat, bankLnglat, "#0094FF")
          // }
        }
        // if(lnglat == res.data.lnglat){
        //   if(_this.vehicleInfoSwitch){
        //     _this.vehicleInfoWindow.open(_this.map, res.data.lnglat);
        //   }else{
        //     _this.vehicleInfoWindow.close()
        //   }
        // }else{
        //   _this.vehicleInfoSwitch=true
        //   _this.vehicleInfoWindow.open(_this.map, res.data.lnglat);
        // }
        _this.vehicleInfoSwitch = !_this.vehicleInfoSwitch;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    // 初始化地图及地图相关插件
    initMap() {
      let _this = this;
      this.map = new AMap.Map("map-box", {
        resizeEnable: true,
        zoom: 12,
        zooms: [3, 20],
        expandZoomRange: true,
        mapStyle: "amap://styles/grey"
      });
      // // 判断地图中心点
      // let detailPosition = sessionStorage.getItem("detailPosition");
      // let monitorLnglat = sessionStorage.getItem("monitorLnglat");
      // if (detailPosition) {
      //   detailPosition = detailPosition.split(",");
      //   console.log(detailPosition);

      //   _this.map.setCenter(detailPosition);
      // } else if (monitorLnglat) {
      //   monitorLnglat = monitorLnglat.split(",");
      //   console.log(monitorLnglat);
      //   _this.map.setCenter([121.843686, 29.587602]);
      // } else {
      //   sessionStorage.removeItem("monitorLnglat");
      //   // 获取当前用户 ip 所在城市
      //   AMap.plugin("AMap.CitySearch", function() {
      //     var citySearch = new AMap.CitySearch();
      //     citySearch.getLocalCity((status, result) => {
      //       if (status === "complete" && result.info === "OK") {
      //         // 查询成功，result即为当前所在城市信息
      //         complete(result);
      //       } else {
      //         error(result);
      //       }
      //     });
      //     function complete(result) {
      //       _this.map.setBounds(result.bounds);
      //     }
      //     function error(result) {
      //       _this.$message.warning(result);
      //     }
      //   });
      // }
      AMap.plugin("AMap.CitySearch", function() {
        var citySearch = new AMap.CitySearch();
        _this.map.addControl(citySearch);
        let monitorLnglat =
          sessionStorage.getItem("detailPosition") ||
          sessionStorage.getItem("monitorLnglat");
        // 车辆定位坐标为空和为（0,0）时，地图默认中心点为登录用户ip城市
        if (
          monitorLnglat != undefined &&
          monitorLnglat != "" &&
          monitorLnglat != "0,0"
        ) {
          _this.map.setCenter(
            _this.$store.state.MenuStore.position || monitorLnglat.split(",")
          );
        } else {
          console.log("--------monitorLnglat---------");
          // 获取城市定位信息
          citySearch.getLocalCity();
          // 返回定位信息
          AMap.event.addListener(citySearch, "complete", result => {
            _this.map.setBounds(result.bounds);
          });
          // 返回定位出错信息
          AMap.event.addListener(citySearch, "error", error => {
            _this.$message.warning(error.message);
          });
        }
      });
      // // 车辆信息窗体
      // this.vehicleInfoWindow = new AMap.Marker({
      //   map: _this.map,
      //   content: this.$refs.vehicleInfowindow.$el,
      //   zIndex: 300,
      //   offset: new AMap.Pixel(30, -40),
      // });
      // this.vehicleInfoWindow = new AMap.InfoWindow({
      //   isCustom: true, //使用自定义窗体
      //   content: this.$refs.vehicleInfowindow.$el,
      //   offset: new AMap.Pixel(27, -45),
      //   anchor: "top-left",
      //   closeWhenClickMap: true,
      //   autoMove: true,
      // });
      // 基站信息窗体
      this.baseStationInfoWindow = new AMap.InfoWindow({
        isCustom: true, //使用自定义窗体
        content: _this.$refs.baseStationInfowindow.$el,
        offset: new AMap.Pixel(20, -45),
        anchor: "top-left",
        closeWhenClickMap: true,
        autoMove: true
      });
      // 初始化地图路线查询插件
      AMap.plugin("AMap.Driving", function() {
        _this.driving = new AMap.Driving({
          policy: AMap.DrivingPolicy.LEAST_FEE,
          hideMarkers: true,
          isOutline: false,
          autoFitView: true
        });
      });
      // scale 比例尺
      AMap.plugin(["AMap.Scale"], () => {
        this.scale = new AMap.Scale({
          visible: true
        });
        this.map.addControl(this.scale);
      });
      // 点击地图，清除路线规划和车辆信息窗体
      AMap.event.addListener(this.map, "click", function() {
        // 关闭input下拉框
        _this.$refs.selectInput.activated = false;
        if (_this.routeLine) {
          _this.driving.clear();
          _this.map.remove(_this.routeLine);
          _this.routeLine = null;
          _this.drivingRoutelVin = null;
        }
        if (_this.vehicleInfoWindow) {
          _this.vehicleInfoWindow.hide();
        }
      });
      var mkIcon = new AMap.Icon({
        size: new AMap.Size(30, 15),
        image: require("@/assets/images/checked.gif"),
        imageSize: new AMap.Size(30, 15)
        // 图标取图偏移量
      });
      this.checkedBank = new AMap.Marker({
        icon: mkIcon,
        zIndex: 90,
        offset: new AMap.Pixel(-13, -6)
      });
    },
    // 车辆概况环形图初始化相关配置
    initCharts(id, color, num) {
      let _this = this;
      let otherNum = this.vehicleTotalNum - num;
      const element = document.getElementById(id);
      if (element) {
        this.id = this.$echarts.init(element);
        this.id.setOption({
          grid: {
            left: "0%",
            right: "0%",
            bottom: "0%",
            containLabel: true
          },
          color: [color, "#2D4262"],
          series: [
            {
              type: "pie",
              radius: ["50%", "70%"],
              hoverAnimation: false,
              avoidLabelOverlap: false,
              label: {
                show: false,
                position: "center"
              },
              labelLine: {
                show: false
              },
              data: [num, otherNum]
            }
          ]
        });
        window.addEventListener("resize", () => {
          _this.id.resize();
        });
      }
    },
    // 月发电量,派单量柱状图初始化
    initBankCharts(id, color, datax, datay) {
      let _this = this;
      let showed = datax.length > 0 ? false : true;
      let unit = color == "#5B6CC4" ? "单" : "KW·H";
      let xUnit = "";
      if (id == "bankOrderCharts" || id == "bankPowerCharts") {
        xUnit = "月";
      } else {
        xUnit = "号";
      }
      const element = document.getElementById(id);
      if (element) {
        element.innerHTML = "";
        element.removeAttribute("_echarts_instance_");
        this.id = this.$echarts.init(element);
        this.id.setOption({
          title: {
            show: showed,
            text: "暂无数据..",
            left: "center",
            top: "center",
            textStyle: {
              fontWeight: "normal",
              color: "#999999"
            }
          },
          tooltip: {
            trigger: "axis",
            formatter: function(params) {
              return params[0].data + unit;
            },
            axisPointer: {
              label: {
                backgroundColor: "#34FFF0"
              }
            }
          },
          grid: {
            left: "0%",
            right: "5%",
            bottom: "5%",
            top: "8%",
            containLabel: true
          },
          xAxis: {
            type: "category",
            axisLabel: {
              formatter: "{value}" + xUnit,
              color: "#97ABEA"
            },
            // data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            data: datax
            // splitLine: {
            //   show: false,
            // },
          },
          yAxis: {
            type: "value",
            splitLine: {
              show: false
            },
            axisLabel: { color: "#97ABEA" },
            axisTick: {
              show: false
            }
          },
          series: [
            {
              data: datay,
              type: "bar",
              itemStyle: {
                color: color
              },
              labelLine: {
                normal: {
                  show: false
                }
              }
            }
          ]
        });
        this.id.off("click");
        this.id.on("click", data => {
          if (id == "bigChartsTwo") {
            return;
          } else if (id == "bigChartsOne") {
            this.activeName = "third";
            let year = this.chartVal.split("-")[0];
            let months = this.chartVal.split("-")[1];
            let day = data.name > 9 ? data.name : "0" + data.name;
            this.timeDay = year + "-" + months + "-" + day + " 00:00:00";
            this.queryOrderList();
          } else if (id == "bankPowerCharts") {
            this.activeName = "second";
            let year = new Date().getFullYear();
            this.months = data.name > 9 ? data.name : "0" + data.name;
            this.chartVal = year + "-" + this.months + "-01 00:00:00";
            this.dialogVisible = true;
            this.chartTitle = this.bankInfowindowData.name + "统计详情";
            this.stationId = this.bankInfowindowData.stationId;
            this.getBankPower("bigChartsTwo", this.stationId, this.chartVal);
          } else {
            this.activeName = "first";
            let year = new Date().getFullYear();
            this.months = data.name > 9 ? data.name : "0" + data.name;
            this.chartVal = year + "-" + this.months + "-01 00:00:00";
            this.dialogVisible = true;
            this.chartTitle = this.bankInfowindowData.name + "统计详情";
            this.stationId = this.bankInfowindowData.stationId;
            this.getBankOrder("bigChartsOne", this.stationId, this.chartVal);
          }
          return;
        });
        window.addEventListener("resize", () => {
          _this.id.resize();
        });
      }
    },
    // 区域发电量占比环形图
    initPowerScaleCharts(data) {
      let _this = this;
      this.powerScale = this.$echarts.init(
        document.getElementById("powerScale")
      );
      this.powerScale.setOption({
        tooltip: {
          trigger: "item",
          formatter: function(params) {
            let topAreaName = params.data.topAreaName;
            let name = params.data.name;
            let percent = params.percent + "%";
            let value = params.data.value;
            return (
              topAreaName +
              "<br/>" +
              name +
              "<br/>" +
              percent +
              "<br/>" +
              value +
              "KW·H"
            );
          },
          axisPointer: {
            label: {
              backgroundColor: "#34FFF0"
            }
          }
        },
        legend: {
          icon: "circle",
          orient: "vertical",
          show: true,
          left: 0,
          top: 5,
          bottom: 5,
          itemWidth: 8, // 设置宽度
          itemHeight: 8, // 设置高度
          itemGap: 8, // 设置间距，
          textStyle: {
            color: "#fff",
            fontSize: 14
          }
        },
        grid: {
          left: "0%",
          right: "0%",
          bottom: "5%",
          top: "8%",
          containLabel: true
        },
        color: _this.colorArr,
        series: [
          {
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            hoverAnimation: false,
            label: {
              show: false,
              position: "center"
            },
            labelLine: {
              show: false
            },
            data: data
          }
        ]
      });
      window.addEventListener("resize", () => {
        _this.powerScale.resize();
      });
    },
    // 区域发电量Top5
    initPowerTopCharts(datax, datay) {
      let _this = this;
      this.powerTop = this.$echarts.init(document.getElementById("powerTop"));
      this.powerTop.setOption({
        grid: {
          left: "0%",
          right: "15%",
          bottom: "5%",
          top: "18%",
          containLabel: true
        },
        tooltip: {
          formatter: function(params) {
            return params.name;
          }
        },
        xAxis: {
          show: false
        },
        yAxis: {
          inverse: true,
          triggerEvent: true,
          splitLine: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            color: "#ffffff",
            formatter: function(value) {
              let str = value.split("-")[0];
              return str;
            }
          },
          axisTick: {
            show: false
          },
          data: datax,
          type: "category"
        },
        series: [
          {
            type: "bar",
            stack: "chart",
            z: 3,
            barWidth: 12,
            // data: [120, 200, 150, 80, 70, 110, 130],
            data: datay,
            label: {
              normal: {
                position: "right",
                show: true,
                color: "white",
                formatter: "{c}分钟"
              }
            },
            itemStyle: {
              normal: {
                barBorderRadius: 5,
                color: function(params) {
                  var colorlist = [
                    "#03C1D6",
                    "#A380DD",
                    "#1074F6",
                    "#E59D4A",
                    "#263C5C"
                  ];
                  return colorlist[params.dataIndex];
                }
              }
            }
          }
        ]
      });
      window.addEventListener("resize", () => {
        _this.powerTop.resize();
      });
    },
    // 区域月派单量折线图初始化
    initAreaOrderCharts(id, datax, datay) {
      let _this = this;
      let showed = datax.length > 0 ? false : true;
      let xUnit = "";
      if (id == "areaOrderCharts") {
        xUnit = "月";
      } else {
        xUnit = "号";
      }
      const element = document.getElementById(id);
      if (element) {
        element.innerHTML = "";
        element.removeAttribute("_echarts_instance_");
        this.id = this.$echarts.init(element);
        this.id.setOption({
          title: {
            show: showed,
            text: "暂无数据..",
            left: "center",
            top: "center",
            textStyle: {
              fontWeight: "normal",
              color: "#999999"
            }
          },
          tooltip: {
            trigger: "axis",
            formatter: function(params) {
              return params[0].data + "单";
            },
            axisPointer: {
              label: {
                backgroundColor: "#00FAC0"
              }
            }
          },
          grid: {
            left: "0%",
            right: "5%",
            bottom: "5%",
            top: "8%",
            containLabel: true
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            axisLabel: {
              formatter: "{value}" + xUnit,
              color: "#97ABEA"
            },
            data: datax,
            splitLine: {
              show: false
            }
          },
          yAxis: {
            type: "value",
            splitLine: {
              show: false
            },
            axisLabel: { color: "#97ABEA" },
            axisTick: {
              show: false
            }
          },
          series: [
            {
              data: datay,
              // data: [22, 32, 10,33, 40, 44, 46],
              type: "line",
              itemStyle: {
                color: "#00FAC0"
              },
              smooth: true,
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "rgba(0,250,192,0.5)"
                  },
                  {
                    offset: 1,
                    color: "rgba(0,250,192,0)"
                  }
                ])
              },
              labelLine: {
                normal: {
                  show: false
                }
              }
            }
          ]
        });
        this.id.off("click");
        this.id.on("click", data => {
          if (id == "bigChartsOne") {
            this.activeName = "third";
            let year = this.chartVal.split("-")[0];
            let months = this.chartVal.split("-")[1];
            let day = data.name > 9 ? data.name : "0" + data.name;
            this.timeDay = year + "-" + months + "-" + day + " 00:00:00";
            this.queryOrderList();
          } else {
            this.activeName = "first";
            this.stationId = null;
            let year = new Date().getFullYear();
            this.months = data.name > 9 ? data.name : "0" + data.name;
            this.chartVal = year + "-" + this.months + "-01 00:00:00";
            this.dialogVisible = true;
            this.chartTitle = "数据统计详情";
            this.getAreaOrderCharts("bigChartsOne", this.chartVal);
          }
        });
        window.addEventListener("resize", () => {
          _this.id.resize();
        });
      }
    },
    // 区域月发电量柱状图初始化
    initAreaPowerCharts(id, datax, datay, datayT) {
      let _this = this;
      let showed = datax.length > 0 ? false : true;
      // let itemHeight = ""
      let barWidth = "";
      let xUnit = "";
      if (id == "areaPowerCharts") {
        barWidth = 8;
        // itemHeight = 8
        xUnit = "月";
      } else {
        barWidth = "";
        // itemHeight = 12
        xUnit = "号";
      }
      const element = document.getElementById(id);
      if (element) {
        element.innerHTML = "";
        element.removeAttribute("_echarts_instance_");
        this.id = this.$echarts.init(element);
        this.id.setOption({
          title: {
            show: showed,
            text: "暂无数据..",
            left: "center",
            top: "center",
            textStyle: {
              fontWeight: "normal",
              color: "#999999"
            }
          },
          // legend: {
          //   icon: "circle",
          //   orient: "vertical",
          //   data: ["工单内", "工单外"],
          //   itemHeight: itemHeight,
          //   textStyle: {
          //     //图例文字的样式
          //     color: "#97ABEA",
          //     fontSize: 12,
          //   },
          //   x: "right",
          //   top: "0%",
          // },
          tooltip: {
            trigger: "axis",
            confine: true,
            formatter: function(params) {
              return (
                params[0].name +
                xUnit +
                "<br/>" +
                "总发电量:" +
                (params[0].value + params[1].value).toFixed(2) +
                "KW·H" +
                "<br/>" +
                params[0].marker +
                params[0].seriesName +
                ":" +
                params[0].value +
                "KW·H" +
                "<br/>" +
                params[1].marker +
                params[1].seriesName +
                ":" +
                params[1].value +
                "KW·H"
              );
            },
            axisPointer: {
              label: {
                backgroundColor: "#34FFF0"
              }
            }
          },
          grid: {
            left: "0%",
            right: "5%",
            bottom: "5%",
            top: "8%",
            containLabel: true
          },
          xAxis: {
            type: "category",
            axisLabel: {
              formatter: "{value}" + xUnit,
              color: "#97ABEA"
            },
            data: datax
          },
          yAxis: {
            type: "value",
            splitLine: {
              show: false
            },
            axisLabel: { color: "#97ABEA" },
            axisTick: {
              show: false
            }
          },
          series: [
            {
              name: "工单内",
              stack: "发电量",
              type: "bar",
              barWidth: barWidth,
              data: datay,
              itemStyle: {
                barBorderRadius: [0, 0, 5, 5],
                color: "#008BD6"
              },
              emphasis: {
                focus: "series"
              }
            },
            {
              name: "工单外",
              stack: "发电量",
              type: "bar",
              barWidth: barWidth,
              data: datayT,
              // data: [220, 182, 191, 234, 290, 330, 310],
              itemStyle: {
                barBorderRadius: [5, 5, 0, 0],
                color: "#f7cb52"
              },
              emphasis: {
                focus: "series"
              }
            }
          ]
        });
        this.id.off("click");
        this.id.on("click", data => {
          if (id == "bigChartsTwo") {
            return;
          } else {
            this.activeName = "second";
            this.stationId = null;
            let year = new Date().getFullYear();
            this.months = data.name > 9 ? data.name : "0" + data.name;
            this.chartVal = year + "-" + this.months + "-01 00:00:00";
            this.dialogVisible = true;
            this.chartTitle = "数据统计详情";
            this.getAreaPowerCharts("bigChartsTwo", this.chartVal);
          }
        });
        window.addEventListener("resize", () => {
          _this.id.resize();
        });
      }
    },
    // 关闭银行详情
    closeBank() {
      this.bankShow = false;
      this.orderShow = false;
      this.bankRoute = false;
      this.waterFlag = false;
      this.stationId = null;
      this.bankType = null;
      this.drivingRoutelVin = null;
      this.baseStationInfoWindow.close();
      this.map.remove(this.checkedBank);
      clearInterval(this.orderTimer);
      sessionStorage.removeItem("bankLnglat");
      if (this.routeLine) {
        this.driving.clear();
        this.map.remove(this.routeLine);
        this.routeLine = null;
      }
    },
    createColorCode() {
      this.colorArr = [];
      let color = [
        "#1074f6",
        "#a380dd",
        "#03c1d6",
        "#e59d4a",
        "#04d568",
        "#54c2e1",
        "#f7cb52",
        "#fc3ea8",
        "#1099f0",
        "#263c5c"
      ];
      for (var i = 0; i < this.dynamoList.length; i++) {
        this.colorArr.push(color[i]);
      }
      return this.colorArr;
    },
    initWebSocket() {
      // 初始化websocket
      // ws地址
      const sessionId = window.sessionStorage.getItem("sessionId");
      // const wsuri = process.env.WS_API + `?user-number=${userNumber}`
      // const wsuri = `ws://192.168.90.152:8070/monitor;JSESSIONID=${sessionId}`; //测试环境websocket地址
      const wsuri = `ws://116.63.189.185:9070/monitor;JSESSIONID=${sessionId}`; //运营环境websocket地址
      this.websock = new WebSocket(wsuri);
      // 监听socket打开
      this.websock.onopen = () => {
        console.log("浏览器WebSocket已打开");
        this.refreshMonitorData();
        if (this.hasPerm("maintain:monitor:order:mouth:area")) {
          this.getAreaOrderCharts("areaOrderCharts");
        }
        if (this.hasPerm("maintain:monitor:dynamo:mouth:area")) {
          this.getAreaPowerCharts("areaPowerCharts");
        }
        if (this.hasPerm("maintain:monitor:area:proportion")) {
          this.getPowerScaleCharts();
          this.initPowerScaleCharts();
          this.initPowerTopCharts();
        }
      };
      this.websock.onmessage = this.websocketonmessage; // 监听socket消息接收
      // this.websock.onsend = this.websocketonsend
      this.websock.onclose = this.websocketclose; // 监听socket关闭
      // 监听socket错误
      // this.websock.onerror = function() {
      //   _this.$notify({
      //     title: '错误',
      //     message: '服务器错误，无法接收实时报警信息',
      //     type: 'error',
      //     duration: 5000
      //   })
      // }
    },
    //  监听socket数据接收
    websocketonmessage(e) {
      const redata = JSON.parse(e.data);
      if (!redata || redata == 1) {
        return;
      } else {
        // 车辆概况
        if (redata.type == 1) {
          this.monitorData.vehicle = redata.data;
          this.initCharts("onlineCharts", "#1074F6", redata.data.onLineCount);
          this.initCharts("offlineCharts", "#A380DD", redata.data.offLineCount);
          this.initCharts("powerCharts", "#03C1D6", redata.data.powerCount);
        }
        // 基站概况
        if (redata.type == 2) {
          this.monitorData.station = redata.data;
        }
        // 工单概况
        if (redata.type == 3) {
          this.monitorData.order = redata.data;
        }
        // 车辆jps移动
        if (redata.type == 10) {
          let _this = this;
          _this.vehicleMarkerList.map(item => {
            //找到对应车辆
            if (item.vin == redata.data.vin) {
              _this.drivingRoutelM = null;
              // _this.driving.search(
              //   new AMap.LngLat(item.lnglat[0], item.lnglat[1]),
              //   new AMap.LngLat(redata.data.lnglat[0], redata.data.lnglat[1]),
              //   (status, result) => {
              //     var path = [];
              //     for (
              //       var i = 0, l = result.routes[0].steps.length;
              //       i < l;
              //       i++
              //     ) {
              //       var step = result.routes[0].steps[i];
              //       for (var j = 0, n = step.path.length; j < n; j++) {
              //         path.push(step.path[j]);
              //       }
              //     }
              //     _this.drivingRoutelM = result.routes[0].distance;
              //     if (
              //       redata.data.absVehicleSpeed > 10 &&
              //       _this.drivingRoutelM > 50
              //     ) {
              //       // 车辆图标
              //       item.vehicle.moveTo(
              //         redata.data.lnglat,
              //         redata.data.absVehicleSpeed * 50,
              //         (val) => {
              //           return val;
              //         }
              //       );
              //       // 车牌号
              //       item.plateNum.moveTo(
              //         redata.data.lnglat,
              //         redata.data.absVehicleSpeed * 50,
              //         (val) => {
              //           return val;
              //         }
              //       );
              //       if (item.vin == _this.vin) {
              //         //当前车辆信息窗体被打开
              //         _this.vehicleInfoWindow.moveTo(
              //           redata.data.lnglat,
              //           redata.data.absVehicleSpeed * 50,
              //           (val) => {
              //             return val;
              //           }
              //         );
              //         // _this.vehicleInfoWindow.setPosition(redata.data.lnglat)
              //       }
              //       // 车辆加油
              //       // if (item.oil) {
              //       //   item.oil.moveTo(
              //       //     redata.data.lnglat,
              //       //     redata.data.absVehicleSpeed * 50,
              //       //     (val) => {
              //       //       return val
              //       //     }
              //       //   )
              //       // }
              //       // 车辆发电
              //       if (item.power) {
              //         item.power.moveTo(
              //           redata.data.lnglat,
              //           redata.data.absVehicleSpeed * 50,
              //           (val) => {
              //             return val;
              //           }
              //         );
              //       }
              //     } else if (
              //       redata.data.absVehicleSpeed > 10 &&
              //       50 > _this.drivingRoutelM
              //     ) {
              //       // 车辆图标
              //       item.vehicle.moveTo(
              //         redata.data.lnglat,
              //         redata.data.absVehicleSpeed * 20,
              //         (val) => {
              //           return val;
              //         }
              //       );
              //       // 车牌号
              //       item.plateNum.moveTo(
              //         redata.data.lnglat,
              //         redata.data.absVehicleSpeed * 20,
              //         (val) => {
              //           return val;
              //         }
              //       );
              //       if (item.vin == _this.vin) {
              //         //当前车辆信息窗体被打开
              //         _this.vehicleInfoWindow.moveTo(
              //           redata.data.lnglat,
              //           redata.data.absVehicleSpeed * 20,
              //           (val) => {
              //             return val;
              //           }
              //         );
              //         // _this.vehicleInfoWindow.setPosition(redata.data.lnglat)
              //       }
              //       // 车辆加油
              //       // if (item.oil) {
              //       //   item.oil.moveTo(
              //       //     redata.data.lnglat,
              //       //     redata.data.absVehicleSpeed * 20,
              //       //     (val) => {
              //       //       return val
              //       //     }
              //       //   )
              //       // }
              //       // 车辆发电
              //       if (item.power) {
              //         item.power.moveTo(
              //           redata.data.lnglat,
              //           redata.data.absVehicleSpeed * 20,
              //           (val) => {
              //             return val;
              //           }
              //         );
              //       }
              //     } else if (
              //       redata.data.absVehicleSpeed <= 100 &&
              //       _this.drivingRoutelM > 0
              //     ) {
              item.vehicle.setPosition(redata.data.lnglat);
              item.plateNum.setPosition(redata.data.lnglat);
              if (item.power) {
                item.power.setPosition(redata.data.lnglat);
              }
              if (item.oil) {
                item.oil.setPosition(redata.data.lnglat);
              }
              if (item.vin == _this.vin) {
                _this.vehicleInfoWindow.setPosition(redata.data.lnglat);
              }
              // }
              item.lnglat = redata.data.lnglat;
              // }
              // );
              // // ------------是否能解决mac系统地图闪烁问题start-------
              // item.vehicle.moveTo(redata.data.lnglat,redata.data.absVehicleSpeed*50,(val)=>{
              //   return val
              // })
              // item.plateNumMarker.moveTo(redata.data.lnglat,redata.data.absVehicleSpeed*50,(val)=>{
              //   return val
              // })
              // item.lnglat=redata.data.lnglat
              // ------------是否能解决mac系统地图闪烁问题end-------
              if (item.vin == _this.drivingRoutelVin) {
                //当前车辆路线被查看
                if (_this.routeLine) {
                  _this.driving.clear();
                  _this.map.remove(_this.routeLine);
                  _this.routeLine = null;
                }
                if (
                  redata.data.destLnglat &&
                  redata.data.destLnglat.length > 0
                ) {
                  //车辆自己有目的地
                  _this.drawRouteLine(
                    redata.data.lnglat,
                    redata.data.destLnglat,
                    "#00E46B"
                  );
                } else {
                  // let bankLnglat = sessionStorage.getItem("bankLnglat") //打开的是当前站址路线
                  // if (bankLnglat) {
                  //   bankLnglat = bankLnglat.split(",")
                  //   _this.drawRouteLine(
                  //     redata.data.lnglat,
                  //     bankLnglat,
                  //     "#0094FF"
                  //   )
                  // } else {
                  //   return
                  // }
                }
              }
            }
          });
        }
        // // 车辆加油状态
        // if (redata.type == 11) {
        //   this.vehicleMarkerList.map((item) => {
        //     if (redata.data.vin == item.vin) {
        //       if (redata.data.status == 1) {
        //         //加油
        //         if (
        //           item.oil == "" ||
        //           item.oil == undefined ||
        //           item.oil == null
        //         ) {
        //           var oilContent =
        //             "<img style='width:14px;height:18px'  src='" +
        //             require("@/assets/images/monitor/icon-fueling.png") +
        //             "'/>"
        //           this.oilStateMarker = new AMap.Marker({
        //             zIndex: 200,
        //             content: oilContent,
        //             position: item.lnglat,
        //             offset: new AMap.Pixel(-30, 8),
        //             map: this.map,
        //           })
        //           this.map.add(this.oilStateMarker)
        //           item.oil = this.oilStateMarker
        //         }
        //       } else {
        //         //停止加油
        //         this.map.remove(item.oil)
        //         item.oil = ""
        //       }
        //     }
        //   })
        // }
        // 车辆详情
        if (redata.type == 12) {
          if (this.vin == redata.data.vin) {
            // 当前打开的信息窗体
            this.vehicleInfoWindowData = redata.data;
            this.stationVehicleId = this.vehicleInfoWindowData.stationId;
          }
          this.vehicleMarkerList.map(item => {
            if (redata.data.vin == item.vin) {
              // if (redata.data.oilPumpingState == 1) {
              //   //加油
              //   if (
              //     item.oil == "" ||
              //     item.oil == undefined ||
              //     item.oil == null
              //   ) {
              //     var oilContent =
              //       "<img style='width:14px;height:18px'  src='" +
              //       require("@/assets/images/monitor/icon-fueling.png") +
              //       "'/>"
              //     // this.oilStateMarker = new AMap.Marker({
              //     //   zIndex: 200,
              //     //   content: oilContent,
              //     //   position: item.lnglat,
              //     //   offset: new AMap.Pixel(-30, 8),
              //     //   map: this.map,
              //     // })
              //     // this.map.add(this.oilStateMarker)
              //     // item.oil = this.oilStateMarker
              //   }
              // } else {
              //   //停止加油
              //   // this.map.remove(item.oil)
              //   // item.oil = ""
              // }
            }
          });
        }
        // 工单进度
        if (redata.type == 13) {
          if (redata.data.stationId == this.stationId) {
            //接受的数据和当前打开的站址ID一样
            if (redata.data.close == 2) {
              //解除派单状态
              this.errorStatus = 1;
              this.orderShow = false;
              this.orderTitle = "派单";
              this.orderDisabled = false;
              if (!this.justFault) {
                //只显示告警基站按钮状态
                //正常状态不显示
                this.closeBank();
              }
              if (this.bankType == 1 && this.switchList[0].switchStatus) {
                //正常基站按钮状态
                //当前打开的是正常基站，并被关闭
                this.closeBank();
              }
            } else {
              //派单状态
              this.orderTitle = "已派单";
              this.orderDisabled = true;
              this.orderDesc = redata.data;
              this.queryTime(redata.data.startTime);
              if (redata.data.status != 1) {
                sessionStorage.removeItem("bankLnglat");
              }
            }
          }
          if (redata.data.stationId == this.stationVehicleId) {
            //当前查看路线的车辆工单状态改变
            if (redata.data.close == 2) {
              //解除派单状态
              if (
                !this.justFault ||
                (this.bankType == 1 && this.switchList[1].switchStatus)
              ) {
                //正常状态站址不显示
                if (this.routeLine) {
                  this.driving.clear();
                  this.map.remove(this.routeLine);
                  this.routeLine = null;
                }
              }
            }
          }
        }
        // 站址状态
        if (redata.type == 14) {
          let lnglat = redata.data.lnglat.split(",");
          let switchList = this.switchList;
          redata.data.lnglat = lnglat;
          switch (redata.data.type) {
            case 1: //基站
              if (redata.data.status == 1) {
                //告警
                this.errorBSMarkers.push(redata.data);
                this.BSMarkers.map((item, index) => {
                  if (item.stationId == redata.data.stationId) {
                    //遍历查找状态改变的站址
                    this.BSMarkers.splice(index, 1);
                  }
                });
              } else {
                //解除告警
                this.BSMarkers.push(redata.data);
                this.errorBSMarkers.map((item, index) => {
                  if (item.stationId == redata.data.stationId) {
                    //遍历查找状态改变的站址
                    this.errorBSMarkers.splice(index, 1);
                  }
                });
              }
              if (this.BSMarks) {
                this.BSMarks.clear();
              }
              if (this.errorBSMarks) {
                this.errorBSMarks.clear();
              }
              this.addBSMarks(this.BsUrl, "2", this.BSMarkers);
              this.addBSMarks(this.faultBsUrl, "1", this.errorBSMarkers);
              if (switchList[0].switchStatus) {
                this.BSMarks.hide();
              } else {
                this.BSMarks.show();
              }
              if (switchList[1].switchStatus) {
                this.errorBSMarks.hide();
              }
              break;
            case 2: //农行
              if (redata.data.status == 1) {
                //告警
                this.errorABOCMarkers.push(redata.data);
                this.ABOCMarkers.map((item, index) => {
                  if (item.stationId == redata.data.stationId) {
                    //遍历查找状态改变的站址
                    this.ABOCMarkers.splice(index, 1);
                  }
                });
              } else {
                //解除告警
                this.ABOCMarkers.push(redata.data);
                this.errorABOCMarkers.map((item, index) => {
                  if (item.stationId == redata.data.stationId) {
                    //遍历查找状态改变的站址
                    this.errorABOCMarkers.splice(index, 1);
                  }
                });
              }
              if (this.ABOCMarks) {
                this.ABOCMarks.clear();
              }
              if (this.errorABOCMarks) {
                this.errorABOCMarks.clear();
              }
              this.addBankMarks(this.ABOCUrl, "4", this.ABOCMarkers);
              this.addBankMarks(this.faultABOCUrl, "3", this.errorABOCMarkers);
              if (switchList[3].switchStatus) {
                this.ABOCMarks.hide();
                this.errorABOCMarks.hide();
              } else {
                if (!this.justFault) {
                  this.ABOCMarks.hide();
                }
              }
              break;
            case 3: //工行
              if (redata.data.status == 1) {
                //告警
                this.errorICBCMarkers.push(redata.data);
                this.ICBCMarkers.map((item, index) => {
                  if (item.stationId == redata.data.stationId) {
                    //遍历查找状态改变的站址
                    this.ICBCMarkers.splice(index, 1);
                  }
                });
              } else {
                //解除告警
                this.ICBCMarkers.push(redata.data);
                this.errorICBCMarkers.map((item, index) => {
                  if (item.stationId == redata.data.stationId) {
                    //遍历查找状态改变的站址
                    this.errorICBCMarkers.splice(index, 1);
                  }
                });
              }
              if (this.ICBCMarks) {
                this.ICBCMarks.clear();
              }
              if (this.errorICBCMarks) {
                this.errorICBCMarks.clear();
              }
              this.addBankMarks(this.ICBCUrl, "6", this.ICBCMarkers);
              this.addBankMarks(this.faultICBCUrl, "5", this.errorICBCMarkers);
              if (switchList[4].switchStatus) {
                this.ICBCMarks.hide();
                this.errorICBCMarks.hide();
              } else {
                if (!this.justFault) {
                  this.ICBCMarks.hide();
                }
              }
              break;
            case 4: //中行
              if (redata.data.status == 1) {
                //告警
                this.errorBOCMarkers.push(redata.data);
                this.BOCMarkers.map((item, index) => {
                  if (item.stationId == redata.data.stationId) {
                    //遍历查找状态改变的站址
                    this.BOCMarkers.splice(index, 1);
                  }
                });
              } else {
                //解除告警
                this.BOCMarkers.push(redata.data);
                this.errorBOCMarkers.map((item, index) => {
                  if (item.stationId == redata.data.stationId) {
                    //遍历查找状态改变的站址
                    this.errorBOCMarkers.splice(index, 1);
                  }
                });
              }
              if (this.BOCMarks) {
                this.BOCMarks.clear();
              }
              if (this.errorBOCMarks) {
                this.errorBOCMarks.clear();
              }
              this.addBankMarks(this.BOCUrl, "8", this.BOCMarkers);
              this.addBankMarks(this.faultBOCUrl, "7", this.errorBOCMarkers);
              if (switchList[5].switchStatus) {
                this.BOCMarks.hide();
                this.errorBOCMarks.hide();
              } else {
                if (!this.justFault) {
                  this.BOCMarks.hide();
                }
              }
              break;
            case 5: //建行
              if (redata.data.status == 1) {
                //告警
                this.errorCCBMarkers.push(redata.data);
                this.CCBMarkers.map((item, index) => {
                  if (item.stationId == redata.data.stationId) {
                    //遍历查找状态改变的站址
                    this.CCBMarkers.splice(index, 1);
                  }
                });
              } else {
                //解除告警
                this.CCBMarkers.push(redata.data);
                this.errorCCBMarkers.map((item, index) => {
                  if (item.stationId == redata.data.stationId) {
                    //遍历查找状态改变的站址
                    this.errorCCBMarkers.splice(index, 1);
                  }
                });
              }
              if (this.CCBMarks) {
                this.CCBMarks.clear();
              }
              if (this.errorCCBMarks) {
                this.errorCCBMarks.clear();
              }
              this.addBankMarks(this.CCBUrl, "10", this.CCBMarkers);
              this.addBankMarks(this.faultCCBUrl, "9", this.errorCCBMarkers);
              if (switchList[6].switchStatus) {
                this.CCBMarks.hide();
                this.errorCCBMarks.hide();
              } else {
                if (!this.justFault) {
                  this.CCBMarks.hide();
                }
              }
              break;
            case 6: //交行
              if (redata.data.status == 1) {
                //告警
                this.errorBCMarkers.push(redata.data);
                this.BCMarkers.map((item, index) => {
                  if (item.stationId == redata.data.stationId) {
                    //遍历查找状态改变的站址
                    this.BCMarkers.splice(index, 1);
                  }
                });
              } else {
                //解除告警
                this.BCMarkers.push(redata.data);
                this.errorBCMarkers.map((item, index) => {
                  if (item.stationId == redata.data.stationId) {
                    //遍历查找状态改变的站址
                    this.errorBCMarkers.splice(index, 1);
                  }
                });
              }
              if (this.BCMarks) {
                this.BCMarks.clear();
              }
              if (this.errorBCMarks) {
                this.errorBCMarks.clear();
              }
              this.addBankMarks(this.BCUrl, "12", this.BCMarkers);
              this.addBankMarks(this.faultBCUrl, "11", this.errorBCMarkers);
              if (switchList[7].switchStatus) {
                this.BCMarks.hide();
                this.errorBCMarks.hide();
              } else {
                if (!this.justFault) {
                  this.BCMarks.hide();
                }
              }
              break;
            case 7: //中石化
              if (redata.data.status == 1) {
                //告警
                this.errorZSHMarkers.push(redata.data);
                this.ZSHMarkers.map((item, index) => {
                  if (item.stationId == redata.data.stationId) {
                    //遍历查找状态改变的站址
                    this.ZSHMarkers.splice(index, 1);
                  }
                });
              } else {
                //解除告警
                this.ZSHMarkers.push(redata.data);
                this.errorZSHMarkers.map((item, index) => {
                  if (item.stationId == redata.data.stationId) {
                    //遍历查找状态改变的站址
                    this.errorZSHMarkers.splice(index, 1);
                  }
                });
              }
              if (this.ZSHMarks) {
                this.ZSHMarks.clear();
              }
              if (this.errorZSHMarks) {
                this.errorZSHMarks.clear();
              }
              this.addBankMarks(this.ZSHUrl, "14", this.ZSHMarkers);
              this.addBankMarks(this.faultZSHUrl, "13", this.errorZSHMarkers);
              if (switchList[8].switchStatus) {
                this.ZSHMarks.hide();
                this.errorZSHMarks.hide();
              } else {
                if (!this.justFault) {
                  this.ZSHMarks.hide();
                }
              }
              break;
            case 8: //中石油
              if (redata.data.status == 1) {
                //告警
                this.errorCNPCMarkers.push(redata.data);
                this.CNPCMarkers.map((item, index) => {
                  if (item.stationId == redata.data.stationId) {
                    //遍历查找状态改变的站址
                    this.CNPCMarkers.splice(index, 1);
                  }
                });
              } else {
                //解除告警
                this.CNPCMarkers.push(redata.data);
                this.errorCNPCMarkers.map((item, index) => {
                  if (item.stationId == redata.data.stationId) {
                    //遍历查找状态改变的站址
                    this.errorCNPCMarkers.splice(index, 1);
                  }
                });
              }
              if (this.CNPCMarks) {
                this.CNPCMarks.clear();
              }
              if (this.errorCNPCMarks) {
                this.errorCNPCMarks.clear();
              }
              this.addBankMarks(this.CNPCUrl, "16", this.CNPCMarkers);
              this.addBankMarks(this.faultCNPCUrl, "15", this.errorCNPCMarkers);
              if (switchList[9].switchStatus) {
                this.CNPCMarks.hide();
                this.errorCNPCMarks.hide();
              } else {
                if (!this.justFault) {
                  this.CNPCMarks.hide();
                }
              }
              break;
            case 9: //浙商银行
              if (redata.data.status == 1) {
                //告警
                this.errorCZBMarkers.push(redata.data);
                this.CZBMarkers.map((item, index) => {
                  if (item.stationId == redata.data.stationId) {
                    //遍历查找状态改变的站址
                    this.CZBMarkers.splice(index, 1);
                  }
                });
              } else {
                //解除告警
                this.CZBMarkers.push(redata.data);
                this.errorCZBMarkers.map((item, index) => {
                  if (item.stationId == redata.data.stationId) {
                    //遍历查找状态改变的站址
                    this.errorCZBMarkers.splice(index, 1);
                  }
                });
              }
              if (this.CZBMarks) {
                this.CZBMarks.clear();
              }
              if (this.errorCZBMarks) {
                this.errorCZBMarks.clear();
              }
              this.addBankMarks(this.CZBUrl, "18", this.CZBMarkers);
              this.addBankMarks(this.faultCZBUrl, "17", this.errorCZBMarkers);
              if (switchList[10].switchStatus) {
                this.CZBMarks.hide();
                this.errorCZBMarks.hide();
              } else {
                if (!this.justFault) {
                  this.CZBMarks.hide();
                }
              }
              break;
            case 10: //华夏银行
              if (redata.data.status == 1) {
                //告警
                this.errorHXMarkers.push(redata.data);
                this.HXMarkers.map((item, index) => {
                  if (item.stationId == redata.data.stationId) {
                    //遍历查找状态改变的站址
                    this.HXMarkers.splice(index, 1);
                  }
                });
              } else {
                //解除告警
                this.HXMarkers.push(redata.data);
                this.errorHXMarkers.map((item, index) => {
                  if (item.stationId == redata.data.stationId) {
                    //遍历查找状态改变的站址
                    this.errorHXMarkers.splice(index, 1);
                  }
                });
              }
              if (this.HXMarks) {
                this.HXMarks.clear();
              }
              if (this.errorHXMarks) {
                this.errorHXMarks.clear();
              }
              this.addBankMarks(this.HXUrl, "20", this.HXMarkers);
              this.addBankMarks(this.faultHXUrl, "19", this.errorHXMarkers);
              if (switchList[11].switchStatus) {
                this.HXMarks.hide();
                this.errorHXMarks.hide();
              } else {
                if (!this.justFault) {
                  this.HXMarks.hide();
                }
              }
              break;
            case 11: //邮政银行
              if (redata.data.status == 1) {
                //告警
                this.errorYZMarkers.push(redata.data);
                this.YZMarkers.map((item, index) => {
                  if (item.stationId == redata.data.stationId) {
                    //遍历查找状态改变的站址
                    this.YZMarkers.splice(index, 1);
                  }
                });
              } else {
                //解除告警
                this.YZMarkers.push(redata.data);
                this.errorYZMarkers.map((item, index) => {
                  if (item.stationId == redata.data.stationId) {
                    //遍历查找状态改变的站址
                    this.errorYZMarkers.splice(index, 1);
                  }
                });
              }
              if (this.YZMarks) {
                this.YZMarks.clear();
              }
              if (this.errorYZMarks) {
                this.errorYZMarks.clear();
              }
              this.addBankMarks(this.YZUrl, "22", this.YZMarkers);
              this.addBankMarks(this.faultYZUrl, "21", this.errorYZMarkers);
              if (switchList[12].switchStatus) {
                this.YZMarks.hide();
                this.errorYZMarks.hide();
              } else {
                if (!this.justFault) {
                  this.YZMarks.hide();
                }
              }
              break;
            case 12: //中信银行
              if (redata.data.status == 1) {
                //告警
                this.errorZXMarkers.push(redata.data);
                this.ZXMarkers.map((item, index) => {
                  if (item.stationId == redata.data.stationId) {
                    //遍历查找状态改变的站址
                    this.ZXMarkers.splice(index, 1);
                  }
                });
              } else {
                //解除告警
                this.ZXMarkers.push(redata.data);
                this.errorZXMarkers.map((item, index) => {
                  if (item.stationId == redata.data.stationId) {
                    //遍历查找状态改变的站址
                    this.errorZXMarkers.splice(index, 1);
                  }
                });
              }
              if (this.ZXMarks) {
                this.ZXMarks.clear();
              }
              if (this.errorZXMarks) {
                this.errorZXMarks.clear();
              }
              this.addBankMarks(this.ZXUrl, "24", this.ZXMarkers);
              this.addBankMarks(this.faultZXUrl, "23", this.errorZXMarkers);
              if (switchList[13].switchStatus) {
                this.ZXMarks.hide();
                this.errorZXMarks.hide();
              } else {
                if (!this.justFault) {
                  this.ZXMarks.hide();
                }
              }
              break;
            case 13: //亚运会
              if (redata.data.status == 1) {
                //告警
                this.errorAGMarkers.push(redata.data);
                this.AGMarkers.map((item, index) => {
                  if (item.stationId == redata.data.stationId) {
                    //遍历查找状态改变的站址
                    this.AGMarkers.splice(index, 1);
                  }
                });
              } else {
                //解除告警
                this.AGMarkers.push(redata.data);
                this.errorAGMarkers.map((item, index) => {
                  if (item.stationId == redata.data.stationId) {
                    //遍历查找状态改变的站址
                    this.errorAGMarkers.splice(index, 1);
                  }
                });
              }
              if (this.AGMarks) {
                this.AGMarks.clear();
              }
              if (this.errorAGMarks) {
                this.errorAGMarks.clear();
              }
              this.addBankMarks(this.AGUrl, "26", this.AGMarkers);
              this.addBankMarks(this.faultAGUrl, "25", this.errorAGMarkers);
              if (switchList[14].switchStatus) {
                this.AGMarks.hide();
                this.errorAGMarks.hide();
              } else {
                if (!this.justFault) {
                  this.AGMarks.hide();
                }
              }
              break;
            case 14: // 联通通信
              if (redata.data.status == 1) {
                //告警
                this.errorUNIMarkers.push(redata.data);
                this.UNIMarkers.map((item, index) => {
                  if (item.stationId == redata.data.stationId) {
                    //遍历查找状态改变的站址
                    this.UNIMarkers.splice(index, 1);
                  }
                });
              } else {
                //解除告警
                this.UNIMarkers.push(redata.data);
                this.errorUNIMarkers.map((item, index) => {
                  if (item.stationId == redata.data.stationId) {
                    //遍历查找状态改变的站址
                    this.errorUNIMarkers.splice(index, 1);
                  }
                });
              }
              if (this.UNIMarks) {
                this.UNIMarks.clear();
              }
              if (this.errorUNIMarks) {
                this.errorUNIMarks.clear();
              }
              this.addBankMarks(this.UNIUrl, "28", this.UNIMarkers);
              this.addBankMarks(this.faultUNIUrl, "27", this.errorUNIMarkers);
              if (switchList[15].switchStatus) {
                this.UNIMarks.hide();
                this.errorUNIMarks.hide();
              } else {
                if (!this.justFault) {
                  this.UNIMarks.hide();
                }
              }
              break;
            case 15: // 移动通信
              if (redata.data.status == 1) {
                //告警
                this.errorMOBMarkers.push(redata.data);
                this.MOBMarkers.map((item, index) => {
                  if (item.stationId == redata.data.stationId) {
                    //遍历查找状态改变的站址
                    this.MOBMarkers.splice(index, 1);
                  }
                });
              } else {
                //解除告警
                this.MOBMarkers.push(redata.data);
                this.errorMOBMarkers.map((item, index) => {
                  if (item.stationId == redata.data.stationId) {
                    //遍历查找状态改变的站址
                    this.errorMOBMarkers.splice(index, 1);
                  }
                });
              }
              if (this.MOBMarks) {
                this.MOBMarks.clear();
              }
              if (this.errorMOBMarks) {
                this.errorMOBMarks.clear();
              }
              this.addBankMarks(this.MOBUrl, "30", this.MOBMarkers);
              this.addBankMarks(this.faultMOBUrl, "29", this.errorMOBMarkers);
              if (switchList[16].switchStatus) {
                this.MOBMarks.hide();
                this.errorMOBMarks.hide();
              } else {
                if (!this.justFault) {
                  this.MOBMarks.hide();
                }
              }
              break;
            case 16: // 民生银行
              if (redata.data.status == 1) {
                //告警
                this.errorMSMarkers.push(redata.data);
                this.MSMarkers.map((item, index) => {
                  if (item.stationId == redata.data.stationId) {
                    //遍历查找状态改变的站址
                    this.MSMarkers.splice(index, 1);
                  }
                });
              } else {
                //解除告警
                this.MSMarkers.push(redata.data);
                this.errorMSMarkers.map((item, index) => {
                  if (item.stationId == redata.data.stationId) {
                    //遍历查找状态改变的站址
                    this.errorMSMarkers.splice(index, 1);
                  }
                });
              }
              if (this.MSMarks) {
                this.MSMarks.clear();
              }
              if (this.errorMSMarks) {
                this.errorMSMarks.clear();
              }
              this.addBankMarks(this.MSUrl, "32", this.MSMarkers);
              this.addBankMarks(this.faultMSUrl, "31", this.errorMSMarkers);
              if (switchList[16].switchStatus) {
                this.MSMarks.hide();
                this.errorMSMarks.hide();
              } else {
                if (!this.justFault) {
                  this.MSMarks.hide();
                }
              }
              break;
            case 17: // 招商银行
              if (redata.data.status == 1) {
                //告警
                this.errorCMBMarkers.push(redata.data);
                this.CMBMarkers.map((item, index) => {
                  if (item.stationId == redata.data.stationId) {
                    //遍历查找状态改变的站址
                    this.CMBMarkers.splice(index, 1);
                  }
                });
              } else {
                //解除告警
                this.CMBMarkers.push(redata.data);
                this.errorCMBMarkers.map((item, index) => {
                  if (item.stationId == redata.data.stationId) {
                    //遍历查找状态改变的站址
                    this.errorCMBMarkers.splice(index, 1);
                  }
                });
              }
              if (this.CMBMarks) {
                this.CMBMarks.clear();
              }
              if (this.errorCMBMarks) {
                this.errorCMBMarks.clear();
              }
              this.addBankMarks(this.CMBUrl, "32", this.CMBMarkers);
              this.addBankMarks(this.faultCMBUrl, "31", this.errorCMBMarkers);
              if (switchList[16].switchStatus) {
                this.CMBMarks.hide();
                this.errorCMBMarks.hide();
              } else {
                if (!this.justFault) {
                  this.CMBMarks.hide();
                }
              }
              break;
          }
        }
        // 车辆在线离线状态
        if (redata.type == 15) {
          this.vehicleMarkerList.map(item => {
            if (redata.data.vin == item.vin) {
              if (redata.data.status == 1) {
                let icon =
                  redata.data.version == 2
                    ? require("@/assets/images/monitor/car-online-2.png")
                    : require("@/assets/images/monitor/car-online.png");
                //在线
                item.vehicle.setIcon(icon);
                item.vehicle.setzIndex(120);
              } else {
                let icon =
                  redata.data.version == 2
                    ? require("@/assets/images/monitor/car-offline-2.0.png")
                    : require("@/assets/images/monitor/car-offline.png");
                //离线
                item.vehicle.setIcon(icon);
                item.vehicle.setzIndex(100);
              }
            }
          });
        }
        // 车辆发电状态
        if (redata.type == 16) {
          this.vehicleMarkerList.map(item => {
            if (redata.data.vin == item.vin) {
              if (redata.data.status == 1) {
                if (item.power) {
                  this.map.remove(item.power);
                  item.power = "";
                }
                //发电
                var powerContent =
                  "<img style='width:14px;height:18px'  src='" +
                  require("@/assets/images/monitor/icon-powering.png") +
                  "'/>";
                this.powerStateMarker = new AMap.Marker({
                  zIndex: 200,
                  content: powerContent,
                  position: item.lnglat,
                  offset: new AMap.Pixel(-30, -12),
                  map: this.map
                });
                this.map.add(this.powerStateMarker);
                item.power = this.powerStateMarker;
              } else if (redata.data.status == 5) {
                if (item.power) {
                  this.map.remove(item.power);
                  item.power = "";
                }
                // 纯发电电动车
                var powerPure =
                  "<img style='width:14px;height:18px'  src='" +
                  require("@/assets/images/monitor/icon-powering-pure.png") +
                  "'/>";
                this.powerStateMarker = new AMap.Marker({
                  zIndex: 200,
                  content: powerPure,
                  position: item.lnglat,
                  offset: new AMap.Pixel(-30, -12),
                  map: this.map
                });
                this.map.add(this.powerStateMarker);
                item.power = this.powerStateMarker;
              } else if (redata.data.status == 3) {
                if (item.power) {
                  this.map.remove(item.power);
                  item.power = "";
                }
                // 异常【】
                var powerException =
                  "<img style='width:32px;height:30px'  src='" +
                  require("@/assets/images/monitor/icon-powerException.png") +
                  "'/>";
                this.powerStateMarker = new AMap.Marker({
                  zIndex: 200,
                  content: powerException,
                  position: item.lnglat,
                  offset: new AMap.Pixel(-56, -8),
                  map: this.map
                });
                this.map.add(this.powerStateMarker);
                item.power = this.powerStateMarker;
              } else {
                //停止发电
                if (item.power) {
                  this.map.remove(item.power);
                  item.power = "";
                }
              }
            }
          });
        }
      }
    },
    //  监听socket关闭
    websocketclose(e) {
      console.log(e);
      // this.websock.close()
      // this.$notify({
      //   title: '错误',
      //   message: 'websocket已关闭，无法接收实时报警信息,请联系汪汪',
      //   type: 'error',
      //   duration: 5000
      // })
    }
  },
  // 消除定时器
  beforeDestroy() {
    this.websock.close();
    sessionStorage.removeItem("bankLnglat");
    clearInterval(this.timer);
    clearInterval(this.websockTimer);
  }
};
</script>

<style lang="scss" scoped>
$font-name: "Arial Negreta", "Arial";

.box-border {
  box-sizing: border-box;
}

.bigCharts {
  width: 1160px;
  height: 500px;
}

.search-menu {
  color: #fff;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  text-align: center;
  width: fit-content;
  margin: 0 auto !important;
  padding: 0;
  border-radius: 3px;

  ::v-deep .el-form-item {
    margin-bottom: 10px !important;
  }
}

::v-deep .input-form-inline {
  padding-top: 2px;
}

::v-deep .error .el-input__inner {
  height: 32px;
  background: rgba(3, 29, 68, 0.8);
  border-radius: 3px;
  border-right: none;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  color: #fff;
  // 边框呼吸闪烁样式
  animation: glow 800ms ease-out infinite alternate;

  @keyframes glow {
    0% {
      border-color: #f00;
      // box-shadow: 0 0 5px rgba(255, 0, 0, 0.2),
      //   inset 0 0 5px rgba(255, 0, 0, 0.1), 0 0 0 rgba(255, 0, 0, 0.3);
      box-shadow: inset -5px 5px 5px rgba(255, 0, 0, 0.2),
        inset -5px -5px 5px rgba(255, 0, 0, 0.2),
        inset 5px -5px 5px rgba(255, 0, 0, 0.2),
        inset 5px 5px 5px rgba(255, 0, 0, 0.2);
    }

    100% {
      border-color: #f00;
      // box-shadow: 0 0 20px rgba(255, 0, 0, 0.6),
      //   inset 0 0 20px rgba(255, 0, 0, 0.4), 0 0 0 rgba(255, 0, 0, 0.6);
      box-shadow: inset -5px 5px 5px rgba(255, 0, 0, 0.2),
        inset -5px -5px 5px rgba(255, 0, 0, 0.2),
        inset 5px -5px 5px rgba(255, 0, 0, 0.2),
        inset 5px 5px 5px rgba(255, 0, 0, 0.2);
    }
  }
}

::v-deep .el-autocomplete-suggestion {
  width: 240px !important;
  margin-top: 8px;
  border-radius: 6px;
  border: 1px solid #1b60cc;
  background: rgba(3, 29, 68, 0.8);
  color: rgba(25, 142, 192, 1);

  .popper__arrow {
    top: -8px;
    border-bottom-color: rgba(31, 177, 239, 1);
  }

  .popper__arrow::after {
    border-bottom-color: rgba(0, 80, 111, 0.9);
  }

  .el-autocomplete-suggestion__wrap {
    padding: 2px;
  }
}

::v-deep .el-autocomplete-suggestion li {
  color: #ffffff;
}

::v-deep .el-autocomplete-suggestion li:hover {
  background-color: rgba(8, 162, 223, 0.8);
  border-radius: 6px;
}

::v-deep .normal .el-input__inner {
  height: 32px;
  background: rgba(3, 29, 68, 0.8);
  border-color: #1b60cc;
  border-right: none;
  border-radius: 3px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  color: #fff;
}

::v-deep .el-input-group__append {
  width: 48px;
  padding: 0;
  border: 1px solid #1b60cc;
  background: #1b60cc;

  .el-button {
    width: 48px;
    margin-right: 0;
  }

  .el-icon-search {
    color: #fff;
    font-size: 16px;
  }
}

.deptName {
  background: #031d44;
  border-radius: 14px;
  color: #fff;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  text-align: center;
  width: fit-content;
  margin: 0 auto !important;
  padding: 5px 10px;
}

.monitor-wrap {
  min-height: 830px;
  min-width: 1650px;
}

.con-wrap {
  position: relative;
  background-color: #fff;
  margin: 0px;
  height: 100%;

  .watch-header {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 100%;
    max-width: 1660px;
    height: 75px;
    background: url("../../../assets/images/monitor/watch-header.png") no-repeat;
    background-size: 100% 75px;

    .header-title {
      width: 100%;
      text-align: center;
      font-size: 32px;
      line-height: 58px;
      font-family: $font-name;
      font-weight: bold;
      color: #00c9f0;
      letter-spacing: 4px;
    }
  }

  .reload-time {
    position: absolute;
    top: 55px;
    left: 30px;
    font-size: 14px;
    font-family: $font-name;
    font-weight: 500;
    color: #fff;
    background: #000;
    padding: 5px;
    border-radius: 4px;
  }

  .switch-survey {
    position: absolute;
    right: 20px;
    top: 105px;
    max-height: calc(100vh - 225px);
    cursor: pointer;
    overflow-y: auto;
    overflow-x: hidden;

    .fault-switch {
      width: 88px;
      height: 52px;
      background: #031d44;
      border-radius: 3px;
      text-align: center;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;

      box-sizing: border-box;

      &:first-child {
        padding-top: 5px;
      }

      .switchBtn {
        /deep/ .el-switch__core {
          width: 30px !important;
          height: 10px;
        }

        /deep/ .el-switch__core:after {
          top: -4px;
          left: 15px;
          width: 16px;
          height: 16px;
        }
      }
    }

    .close-switch {
      margin-top: 10px;
      width: 88px;
      background: #031d44;
      border-radius: 3px;
      padding: 10px 15px;
      box-sizing: border-box;

      .switchItem {
        line-height: 30px;
        position: relative;

        .switchBtn {
          position: absolute;
          top: 3px;
          margin-left: 5px;
        }

        .switchBtnV {
          position: absolute;
          top: 11px;
          margin-left: 5px;
        }

        /deep/ .el-switch__core {
          width: 30px !important;
          height: 10px;
        }

        /deep/ .el-switch__core:after {
          top: -4px;
          left: 15px;
          width: 16px;
          height: 16px;
        }
      }

      img {
        width: 24px;
        height: 24px;
      }

      .imgVehicle {
        width: 24px;
        height: auto;
      }
    }

    /** 修改滚动条 */
    scrollbar-width: thin;
    /* auto | thin | none */
    scrollbar-color: #888 transparent;

    /* Firefox 专用 hack */
    @-moz-document url-prefix() {
      padding-right: 8px;
      /* 预留滚动条空间 */
    }
  }

  .openLeftRetract {
    position: absolute;
    padding: 5px;
    padding-top: 27px;
    width: 10px;
    height: 0px;
    background: #1b60cc;
    opacity: 0.8;
    text-align: center;
    border-radius: 3px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000;
    left: 360px;
    top: 98px;
    cursor: pointer;

    .iconfont {
      font-size: 16px;
      position: absolute;
      top: 7px;
      left: 2px;
    }

    .iconfont:hover {
      color: #000;
    }
  }

  .openRetract {
    position: absolute;
    padding: 5px;
    padding-top: 15px;
    width: 25px;
    height: 0px;
    background: #1b60cc;
    opacity: 0.8;
    border-radius: 3px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000;
    text-align: center;
    left: -805px;
    right: 0px;
    margin: 0 auto;
    bottom: 255px;
    cursor: pointer;

    .iconfont {
      font-size: 16px;
      position: absolute;
      top: 2px;
      left: 10px;
    }

    .iconfont:hover {
      color: #000;
    }
  }

  .survey-wrapper {
    width: 320px;
    height: 735px;
    background: url("../../../assets/images/monitor/left_rightBox.png")
      no-repeat;
    background-size: 320px 735px;
    position: absolute;
    top: 85px;
    padding: 20px 10px;
    box-sizing: border-box;
    // overflow: hidden;
    z-index: 999;

    .survey {
      width: calc(100% - 20px);
      margin: 0 auto;
      margin-bottom: 5px;

      .survey-title {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #97abea;
        margin-bottom: 5px;
      }

      .survey-vehicle {
        width: 100%;
        height: 90px;

        .vehicle {
          position: relative;
          cursor: pointer;

          .vehicle_num {
            position: absolute;
            width: 100%;
            text-align: center;
            left: 0;
            top: 27px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;

            p {
              line-height: 20px;
            }

            .num {
              font-size: 20px;
            }

            .desc {
              font-size: 14px;
            }
          }
        }
      }

      .survey-base {
        width: 290px;
        padding-left: 20px;

        .base {
          width: 72px;
          height: 68px;
          margin: 0px 25px;
          text-align: center;
          background-size: contain;
          background-repeat: no-repeat;
          cursor: pointer;

          .base_num {
            font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            padding-top: 10px;
          }

          .base_title {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
          }
        }

        .allBase {
          background-image: url("../../../assets/images/monitor/allBase.png");
        }

        .faultBase {
          background-image: url("../../../assets/images/monitor/faultBase.png");
        }

        .ordering {
          background-image: url("../../../assets/images/monitor/order_ing.png");
        }

        .order {
          background-image: url("../../../assets/images/monitor/order.png");
        }
      }

      .survey-area {
        width: 100%;
        height: 170px;
      }

      .bankDetail {
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        height: 370px;

        .bank_img {
          width: 300px;
          height: 150px;
        }

        .bank_name {
          font-size: 14px;
          line-height: 25px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          cursor: pointer;
        }

        .bank_message {
          font-size: 12px;
          line-height: 22px;
          margin-bottom: 5px !important;
        }
      }
      .waterDetail {
        color: #fff;
        margin-bottom: 10px !important;
      }
    }
  }

  .left-survey {
    left: 30px;

    .vehicleCharts {
      width: 100%;
      height: 96px;
    }

    .survey {
      overflow: hidden;
    }
  }

  .bottom-survey {
    width: 886px;
    height: 236px;
    background: url("../../../assets/images/monitor/middleBox.png") no-repeat;
    background-size: 880px 230px;
    top: unset;
    bottom: 15px;
    left: 0px;
    right: 0px;
    margin: 0 auto !important;

    .survey {
      width: 420px !important;
      position: relative;

      .year {
        position: absolute;
        left: 186px;
        top: 98px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
      }
    }

    .powerTop {
      .year {
        top: 26px;
        left: 0px;
      }
    }
  }

  .right-survey {
    right: 30px;

    .survey {
      position: relative;

      .close {
        font-size: 24px;
        color: #057dd5;
        position: absolute;
        right: -6px;
        top: -12px;
        cursor: pointer;
      }
      .water-list {
        display: flex;
        flex-wrap: wrap;
        max-height: 300px;
        overflow-y: auto;
        li {
          margin-right: 6px;
          margin-bottom: 6px;
          /deep/ .el-image {
            display: block;
          }
        }
      }
    }

    .survey-area {
      height: 126px !important;
      cursor: pointer;
      // background:#0060FF;
    }
    /** 修改滚动条 */
    scrollbar-width: thin;
    /* auto | thin | none */
    scrollbar-color: #888 transparent;

    /* Firefox 专用 hack */
    @-moz-document url-prefix() {
      padding-right: 8px;
      /* 预留滚动条空间 */
    }
  }

  // 高德地图窗体
  .infoWindow {
    position: relative;
    padding: 10px;
    background: rgba(255, 255, 255, 0.8);
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 20px;
    width: 185px;
    border-radius: 4px;

    .orderTime {
      position: absolute;
      width: 185px;
      line-height: 20px;
      background: rgba(255, 255, 255, 0.8);
      top: -22px;
      left: 0;
      border-radius: 3px;
      padding-left: 10px;
    }

    .infoWindow-detail {
      .carNumber {
        color: #0060ff;
      }

      .vehicleStatus {
        span {
          display: inline-block;
          text-align: center;
          width: 54px;
          height: 20px;
          border-radius: 10px;
          margin-right: 5px;
          color: rgba(255, 255, 255, 0.8);
        }

        .powering {
          background: #00beda;
        }

        .fueling {
          background: #ffa200;
        }

        .routing {
          background: #00cb4c;
        }

        .no-receive {
          background: #888888;
        }

        .no-order {
          background: #0078ff;
        }
      }
    }

    // 三角形
    .delta {
      position: absolute;
      left: -10px;
      top: 30px;
      width: 0;
      height: 0;
      border-top: 8px solid transparent;
      border-right: 10px solid rgba(255, 255, 255, 0.8);
      border-bottom: 8px solid transparent;
    }

    .delta-left {
      position: absolute;
      right: -10px;
      top: 30px;
      width: 0;
      height: 0;
      border-top: 8px solid transparent;
      border-left: 10px solid rgba(255, 255, 255, 0.8);
      border-bottom: 8px solid transparent;
    }

    // 查看详情
    .checkDetail {
      position: absolute;
      right: -30px;
      top: 0;
      width: 20px;
      height: 82px;
      background: rgba(0, 148, 255, 0.8);
      border-radius: 0px 3px 3px 0px;
      color: #fff;
      text-align: center;
      padding: 5px;
      cursor: pointer;
    }

    .checkDetail-left {
      position: absolute;
      left: -30px;
      top: 0;
      width: 20px;
      height: 82px;
      background: rgba(0, 148, 255, 0.8);
      border-radius: 0px 3px 3px 0px;
      color: #fff;
      text-align: center;
      padding: 5px;
      cursor: pointer;
    }

    .direction-left {
      position: absolute;
      left: 0;
      bottom: -20px;
      width: 20px;
      height: 20px;
      line-height: 20px;
    }

    .direction-right {
      position: absolute;
      right: 0;
      bottom: -20px;
      width: 20px;
      height: 20px;
      line-height: 20px;
    }
  }

  .baseStationInfowindow {
    width: 120px;
    padding-top: 7px;

    .delta {
      top: 15px;
    }

    .receipTitle {
      font-size: 14px;
    }
  }

  .orderDesc {
    min-width: 225px;
    max-width: 260px;
    padding: 0 20px;
    box-sizing: border-box;
    height: 70px;
    background: #ffffff;
    opacity: 0.8;
    border-radius: 8px;
    text-align: center;
    position: absolute;
    left: 0;
    right: 0;
    top: 85px;
    margin: auto;

    div {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #0094ff;
      line-height: 37px;
    }

    p {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #000000;
    }
  }
}

// 全屏展示
.fullScreen {
  position: absolute;
  right: 30px;
  top: 50px;
  width: 65px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  background: #1b60cc;
  opacity: 0.8;
  border-radius: 3px;
  font-size: 14px;
  color: #fff;
  cursor: pointer;

  i {
    color: #fff;
  }

  i:hover {
    color: #fff;
  }
}

#map-box {
  width: 100%;
  height: 100%;
  min-height: 720px;
}

/deep/ .el-loading-mask {
  background: rgba(0, 0, 0, 0.8);
}

.receipt-info /deep/ .el-dialog__body {
  color: #333;
}

.receipt-info /deep/ .el-dialog__body {
  padding-left: 40px;
}

.recept-wrap /deep/ .el-dialog__body {
  padding-left: 20px;

  .el-row {
    padding-left: 20px;
  }
}

.receipt-info /deep/ .el-dialog__footer {
  padding-top: 10px;
}

.dialog-label {
  padding-left: 20px;
  font-weight: bold;
}

//详情弹窗样式
.info-box /deep/ .el-dialog {
  width: 1200px;
}

.info-box /deep/ .el-row {
  height: 32px;
  line-height: 32px;
  padding-left: 60px;
  color: #333;
}

.info-box /deep/ .dialog-label {
  font-weight: bold;
}

.con-left {
  width: 50%;
  display: inline-block;
}

.con-right {
  width: 50%;
  display: inline-block;
}

.dialog-title {
  width: 100%;
  height: 20px;
  padding-left: 10px;
  margin-bottom: 10px;
  border-left: 3px solid #0093ff;
  font-size: 14px;
  font-weight: bold;
  color: #333;
  box-sizing: border-box;
}

.time-wrap {
  width: 180px;
  height: 56px;
  padding: 10px;
  background: #ddf0fe;
  box-sizing: border-box;
}

.time-box {
  width: 100%;
  height: 36px;
  line-height: 36px;
  padding: 0 12px;
  border: 2px solid #18232c;
  border-radius: 6px;
  display: inline-block;
  box-sizing: border-box;
}

.time-con {
  float: right;
  font-size: 18px;
  color: #0094ff;
}

::v-deep .amap-scale-text {
  color: #fff;
}
</style>
